/**
 * Content configuration for the skill SEO pages (https://freedomly.io/freelancer/<slug>).
 *
 * Each entry defines one skill page. Entries contain NO text — only translation
 * keys. The actual texts live in src/translations/fi.json and en.json, and every
 * key referenced here must exist in BOTH files.
 *
 * skillKey is the exact skill key stored in the skills DB and mirrored to the
 * freelancer profile listings (publicData.authorSkillsKeys) — SkillSeoPage.duck.js
 * uses it to query freelancers for the page.
 *
 * Authoring guide and syntax rules: docs/skill-seo-page-contents.md
 * NOTE: this file is generated from the skill data — keep entries in this shape.
 */
export const skillSeoPageContents = [
  {
    id: '2d-animation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: '2d_animation',
    path: '/2d-animaatio',
    name: '2dAnimationSkillPage',
    schemaTitle: 'SkillSeoPage.2dAnimationSchemaTitle',
    schemaDescription: 'SkillSeoPage.2dAnimationSchemaDescription',
    heroPill: 'SkillSeoPage.2dAnimationHeroPill',
    heroTitle: 'SkillSeoPage.2dAnimationHeroTitle',
    heroSubtitle: 'SkillSeoPage.2dAnimationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.2dAnimationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.2dAnimationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.2dAnimationFaqQuestion1',
        answer: 'SkillSeoPage.2dAnimationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.2dAnimationFaqQuestion2',
        answer: 'SkillSeoPage.2dAnimationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.2dAnimationFaqQuestion3',
        answer: 'SkillSeoPage.2dAnimationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'motion-graphics',
      'character-design',
      'concept-art',
      '3d-animation',
      'video-effects',
    ],
  },
  {
    id: '3d-animation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: '3d_animation',
    path: '/3d-animaatio',
    name: '3dAnimationSkillPage',
    schemaTitle: 'SkillSeoPage.3dAnimationSchemaTitle',
    schemaDescription: 'SkillSeoPage.3dAnimationSchemaDescription',
    heroPill: 'SkillSeoPage.3dAnimationHeroPill',
    heroTitle: 'SkillSeoPage.3dAnimationHeroTitle',
    heroSubtitle: 'SkillSeoPage.3dAnimationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.3dAnimationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.3dAnimationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.3dAnimationFaqQuestion1',
        answer: 'SkillSeoPage.3dAnimationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.3dAnimationFaqQuestion2',
        answer: 'SkillSeoPage.3dAnimationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.3dAnimationFaqQuestion3',
        answer: 'SkillSeoPage.3dAnimationFaqAnswer3',
      },
    ],
    relatedSkills: ['3d-rendering', '3d-design', '3d-modeling', '2d-animation', 'character-design'],
  },
  {
    id: '3d-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: '3d_design',
    path: '/3d-suunnittelu',
    name: '3dDesignSkillPage',
    schemaTitle: 'SkillSeoPage.3dDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.3dDesignSchemaDescription',
    heroPill: 'SkillSeoPage.3dDesignHeroPill',
    heroTitle: 'SkillSeoPage.3dDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.3dDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.3dDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.3dDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.3dDesignFaqQuestion1',
        answer: 'SkillSeoPage.3dDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.3dDesignFaqQuestion2',
        answer: 'SkillSeoPage.3dDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.3dDesignFaqQuestion3',
        answer: 'SkillSeoPage.3dDesignFaqAnswer3',
      },
    ],
    relatedSkills: ['3d-rendering', '3d-animation', 'cad', '3d-modeling', 'business-card-design'],
  },
  {
    id: '3d-modeling',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: '3d_modeling',
    path: '/3d-mallinnus',
    name: '3dModelingSkillPage',
    schemaTitle: 'SkillSeoPage.3dModelingSchemaTitle',
    schemaDescription: 'SkillSeoPage.3dModelingSchemaDescription',
    heroPill: 'SkillSeoPage.3dModelingHeroPill',
    heroTitle: 'SkillSeoPage.3dModelingHeroTitle',
    heroSubtitle: 'SkillSeoPage.3dModelingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.3dModelingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.3dModelingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.3dModelingFaqQuestion1',
        answer: 'SkillSeoPage.3dModelingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.3dModelingFaqQuestion2',
        answer: 'SkillSeoPage.3dModelingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.3dModelingFaqQuestion3',
        answer: 'SkillSeoPage.3dModelingFaqAnswer3',
      },
    ],
    relatedSkills: ['3d-rendering', 'cad', '3d-animation', '3d-design', '2d-animation'],
  },
  {
    id: '3d-rendering',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: '3d_rendering',
    path: '/3d-renderointi',
    name: '3dRenderingSkillPage',
    schemaTitle: 'SkillSeoPage.3dRenderingSchemaTitle',
    schemaDescription: 'SkillSeoPage.3dRenderingSchemaDescription',
    heroPill: 'SkillSeoPage.3dRenderingHeroPill',
    heroTitle: 'SkillSeoPage.3dRenderingHeroTitle',
    heroSubtitle: 'SkillSeoPage.3dRenderingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.3dRenderingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.3dRenderingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.3dRenderingFaqQuestion1',
        answer: 'SkillSeoPage.3dRenderingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.3dRenderingFaqQuestion2',
        answer: 'SkillSeoPage.3dRenderingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.3dRenderingFaqQuestion3',
        answer: 'SkillSeoPage.3dRenderingFaqAnswer3',
      },
    ],
    relatedSkills: ['3d-design', '3d-animation', '3d-modeling', 'cad', 'brochure-design'],
  },
  {
    id: 'ab-testing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ab_testing',
    path: '/ab-testaus',
    name: 'AbTestingSkillPage',
    schemaTitle: 'SkillSeoPage.abTestingSchemaTitle',
    schemaDescription: 'SkillSeoPage.abTestingSchemaDescription',
    heroPill: 'SkillSeoPage.abTestingHeroPill',
    heroTitle: 'SkillSeoPage.abTestingHeroTitle',
    heroSubtitle: 'SkillSeoPage.abTestingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.abTestingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.abTestingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.abTestingFaqQuestion1',
        answer: 'SkillSeoPage.abTestingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.abTestingFaqQuestion2',
        answer: 'SkillSeoPage.abTestingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.abTestingFaqQuestion3',
        answer: 'SkillSeoPage.abTestingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'growth-hacking',
      'lead-generation',
      'conversion-rate-optimization',
      'web-analytics',
      'usability-testing',
    ],
  },
  {
    id: 'accessibility-testing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'accessibility_testing',
    path: '/saavutettavuustestaus',
    name: 'AccessibilityTestingSkillPage',
    schemaTitle: 'SkillSeoPage.accessibilityTestingSchemaTitle',
    schemaDescription: 'SkillSeoPage.accessibilityTestingSchemaDescription',
    heroPill: 'SkillSeoPage.accessibilityTestingHeroPill',
    heroTitle: 'SkillSeoPage.accessibilityTestingHeroTitle',
    heroSubtitle: 'SkillSeoPage.accessibilityTestingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.accessibilityTestingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.accessibilityTestingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.accessibilityTestingFaqQuestion1',
        answer: 'SkillSeoPage.accessibilityTestingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.accessibilityTestingFaqQuestion2',
        answer: 'SkillSeoPage.accessibilityTestingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.accessibilityTestingFaqQuestion3',
        answer: 'SkillSeoPage.accessibilityTestingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ui-design',
      'website-design',
      'accessible-content',
      'wcag-standards',
      'usability-testing',
    ],
  },
  {
    id: 'accessible-content',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'accessible_content',
    path: '/saavutettava-sisalto',
    name: 'AccessibleContentSkillPage',
    schemaTitle: 'SkillSeoPage.accessibleContentSchemaTitle',
    schemaDescription: 'SkillSeoPage.accessibleContentSchemaDescription',
    heroPill: 'SkillSeoPage.accessibleContentHeroPill',
    heroTitle: 'SkillSeoPage.accessibleContentHeroTitle',
    heroSubtitle: 'SkillSeoPage.accessibleContentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.accessibleContentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.accessibleContentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.accessibleContentFaqQuestion1',
        answer: 'SkillSeoPage.accessibleContentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.accessibleContentFaqQuestion2',
        answer: 'SkillSeoPage.accessibleContentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.accessibleContentFaqQuestion3',
        answer: 'SkillSeoPage.accessibleContentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'copywriting',
      'content-marketing',
      'website-design',
      'content-creation',
      'accessibility-testing',
    ],
  },
  {
    id: 'ad-creatives',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ad_creatives',
    path: '/mainosmateriaalit',
    name: 'AdCreativesSkillPage',
    schemaTitle: 'SkillSeoPage.adCreativesSchemaTitle',
    schemaDescription: 'SkillSeoPage.adCreativesSchemaDescription',
    heroPill: 'SkillSeoPage.adCreativesHeroPill',
    heroTitle: 'SkillSeoPage.adCreativesHeroTitle',
    heroSubtitle: 'SkillSeoPage.adCreativesHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.adCreativesFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.adCreativesFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.adCreativesFaqQuestion1',
        answer: 'SkillSeoPage.adCreativesFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.adCreativesFaqQuestion2',
        answer: 'SkillSeoPage.adCreativesFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.adCreativesFaqQuestion3',
        answer: 'SkillSeoPage.adCreativesFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-cover-design',
      'book-layout',
      'drawing',
      'scriptwriting',
      'packaging-design',
    ],
  },
  {
    id: 'advertising-copywriting',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'advertising_copywriting',
    path: '/mainostekstit',
    name: 'AdvertisingCopywritingSkillPage',
    schemaTitle: 'SkillSeoPage.advertisingCopywritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.advertisingCopywritingSchemaDescription',
    heroPill: 'SkillSeoPage.advertisingCopywritingHeroPill',
    heroTitle: 'SkillSeoPage.advertisingCopywritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.advertisingCopywritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.advertisingCopywritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.advertisingCopywritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.advertisingCopywritingFaqQuestion1',
        answer: 'SkillSeoPage.advertisingCopywritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.advertisingCopywritingFaqQuestion2',
        answer: 'SkillSeoPage.advertisingCopywritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.advertisingCopywritingFaqQuestion3',
        answer: 'SkillSeoPage.advertisingCopywritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'product-description-writing',
      'copywriting',
      'natural-language-processing',
      'blog-writing',
      'proofreading',
    ],
  },
  {
    id: 'ai-agent-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_agent_development',
    path: '/tekoalyagenttien-kehittaminen',
    name: 'AiAgentDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.aiAgentDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiAgentDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.aiAgentDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.aiAgentDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiAgentDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiAgentDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiAgentDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiAgentDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.aiAgentDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiAgentDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.aiAgentDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiAgentDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.aiAgentDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-workflow-automation',
      'automations',
      'ai-strategy',
      'ai-development',
      'machine-learning',
    ],
  },
  {
    id: 'ai-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_development',
    path: '/tekoalyn-kehittaminen',
    name: 'AiDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.aiDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.aiDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.aiDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.aiDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.aiDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.aiDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'machine-learning',
      'deep-learning',
      'api-development',
      'application-architecture',
      'system-architecture',
    ],
  },
  {
    id: 'ai-image-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_image_production',
    path: '/tekoalykuvat',
    name: 'AiImageProductionSkillPage',
    schemaTitle: 'SkillSeoPage.aiImageProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiImageProductionSchemaDescription',
    heroPill: 'SkillSeoPage.aiImageProductionHeroPill',
    heroTitle: 'SkillSeoPage.aiImageProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiImageProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiImageProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiImageProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiImageProductionFaqQuestion1',
        answer: 'SkillSeoPage.aiImageProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiImageProductionFaqQuestion2',
        answer: 'SkillSeoPage.aiImageProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiImageProductionFaqQuestion3',
        answer: 'SkillSeoPage.aiImageProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-video-production',
      'audio-mixing',
      'ai-text-production',
      'motion-graphics',
      '3d-animation',
    ],
  },
  {
    id: 'ai-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_strategy',
    path: '/tekoalystrategia',
    name: 'AiStrategySkillPage',
    schemaTitle: 'SkillSeoPage.aiStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.aiStrategySchemaDescription',
    heroPill: 'SkillSeoPage.aiStrategyHeroPill',
    heroTitle: 'SkillSeoPage.aiStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiStrategyFaqQuestion1',
        answer: 'SkillSeoPage.aiStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiStrategyFaqQuestion2',
        answer: 'SkillSeoPage.aiStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiStrategyFaqQuestion3',
        answer: 'SkillSeoPage.aiStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-agent-development',
      'ai-workflow-automation',
      'automations',
      'ai-development',
      'machine-learning',
    ],
  },
  {
    id: 'ai-text-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_text_production',
    path: '/ai-sisallontuotanto',
    name: 'AiTextProductionSkillPage',
    schemaTitle: 'SkillSeoPage.aiTextProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiTextProductionSchemaDescription',
    heroPill: 'SkillSeoPage.aiTextProductionHeroPill',
    heroTitle: 'SkillSeoPage.aiTextProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiTextProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiTextProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiTextProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiTextProductionFaqQuestion1',
        answer: 'SkillSeoPage.aiTextProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiTextProductionFaqQuestion2',
        answer: 'SkillSeoPage.aiTextProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiTextProductionFaqQuestion3',
        answer: 'SkillSeoPage.aiTextProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-image-production',
      'ai-video-production',
      'natural-language-processing',
      'machine-learning',
      'content-strategy',
    ],
  },
  {
    id: 'ai-video-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_video_production',
    path: '/tekoalyvideot',
    name: 'AiVideoProductionSkillPage',
    schemaTitle: 'SkillSeoPage.aiVideoProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiVideoProductionSchemaDescription',
    heroPill: 'SkillSeoPage.aiVideoProductionHeroPill',
    heroTitle: 'SkillSeoPage.aiVideoProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiVideoProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiVideoProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiVideoProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiVideoProductionFaqQuestion1',
        answer: 'SkillSeoPage.aiVideoProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiVideoProductionFaqQuestion2',
        answer: 'SkillSeoPage.aiVideoProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiVideoProductionFaqQuestion3',
        answer: 'SkillSeoPage.aiVideoProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-image-production',
      'video-effects',
      'ai-development',
      'corporate-video-production',
      'ai-text-production',
    ],
  },
  {
    id: 'ai-workflow-automation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ai_workflow_automation',
    path: '/tekoalyautomaatiot',
    name: 'AiWorkflowAutomationSkillPage',
    schemaTitle: 'SkillSeoPage.aiWorkflowAutomationSchemaTitle',
    schemaDescription: 'SkillSeoPage.aiWorkflowAutomationSchemaDescription',
    heroPill: 'SkillSeoPage.aiWorkflowAutomationHeroPill',
    heroTitle: 'SkillSeoPage.aiWorkflowAutomationHeroTitle',
    heroSubtitle: 'SkillSeoPage.aiWorkflowAutomationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.aiWorkflowAutomationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.aiWorkflowAutomationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.aiWorkflowAutomationFaqQuestion1',
        answer: 'SkillSeoPage.aiWorkflowAutomationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.aiWorkflowAutomationFaqQuestion2',
        answer: 'SkillSeoPage.aiWorkflowAutomationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.aiWorkflowAutomationFaqQuestion3',
        answer: 'SkillSeoPage.aiWorkflowAutomationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ai-agent-development',
      'website-design',
      'ai-strategy',
      'automations',
      'ai-development',
    ],
  },
  {
    id: 'android-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'android_development',
    path: '/android-kehitys',
    name: 'AndroidDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.androidDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.androidDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.androidDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.androidDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.androidDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.androidDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.androidDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.androidDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.androidDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.androidDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.androidDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.androidDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.androidDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ios-development',
      'cross-platform-development',
      'mobile-app-development',
      'web-development',
      'front-end-development',
    ],
  },
  {
    id: 'api-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'api_development',
    path: '/api-kehitys',
    name: 'ApiDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.apiDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.apiDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.apiDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.apiDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.apiDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.apiDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.apiDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.apiDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.apiDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.apiDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.apiDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.apiDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.apiDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'application-architecture',
      'ios-development',
      'machine-learning',
      'cross-platform-development',
      'back-end-development',
    ],
  },
  {
    id: 'application-architecture',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'application_architecture',
    path: '/sovellusarkkitehtuuri',
    name: 'ApplicationArchitectureSkillPage',
    schemaTitle: 'SkillSeoPage.applicationArchitectureSchemaTitle',
    schemaDescription: 'SkillSeoPage.applicationArchitectureSchemaDescription',
    heroPill: 'SkillSeoPage.applicationArchitectureHeroPill',
    heroTitle: 'SkillSeoPage.applicationArchitectureHeroTitle',
    heroSubtitle: 'SkillSeoPage.applicationArchitectureHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.applicationArchitectureFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.applicationArchitectureFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.applicationArchitectureFaqQuestion1',
        answer: 'SkillSeoPage.applicationArchitectureFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.applicationArchitectureFaqQuestion2',
        answer: 'SkillSeoPage.applicationArchitectureFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.applicationArchitectureFaqQuestion3',
        answer: 'SkillSeoPage.applicationArchitectureFaqAnswer3',
      },
    ],
    relatedSkills: [
      'system-architecture',
      'api-development',
      'mobile-app-development',
      'database-management',
      'back-end-development',
    ],
  },
  {
    id: 'article-writing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'article_writing',
    path: '/artikkelien-kirjoittaminen',
    name: 'ArticleWritingSkillPage',
    schemaTitle: 'SkillSeoPage.articleWritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.articleWritingSchemaDescription',
    heroPill: 'SkillSeoPage.articleWritingHeroPill',
    heroTitle: 'SkillSeoPage.articleWritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.articleWritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.articleWritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.articleWritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.articleWritingFaqQuestion1',
        answer: 'SkillSeoPage.articleWritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.articleWritingFaqQuestion2',
        answer: 'SkillSeoPage.articleWritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.articleWritingFaqQuestion3',
        answer: 'SkillSeoPage.articleWritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'crisis-management',
      'media-relations',
      'blog-writing',
      'transcription',
    ],
  },
  {
    id: 'arvr-content-creation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'arvr_content_creation',
    path: '/xr-sisallontuotanto',
    name: 'ArvrContentCreationSkillPage',
    schemaTitle: 'SkillSeoPage.arvrContentCreationSchemaTitle',
    schemaDescription: 'SkillSeoPage.arvrContentCreationSchemaDescription',
    heroPill: 'SkillSeoPage.arvrContentCreationHeroPill',
    heroTitle: 'SkillSeoPage.arvrContentCreationHeroTitle',
    heroSubtitle: 'SkillSeoPage.arvrContentCreationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.arvrContentCreationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.arvrContentCreationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.arvrContentCreationFaqQuestion1',
        answer: 'SkillSeoPage.arvrContentCreationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.arvrContentCreationFaqQuestion2',
        answer: 'SkillSeoPage.arvrContentCreationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.arvrContentCreationFaqQuestion3',
        answer: 'SkillSeoPage.arvrContentCreationFaqAnswer3',
      },
    ],
    relatedSkills: ['augmented-reality', 'virtual-reality', '3d-modeling', '3d-animation'],
  },
  {
    id: 'audio-editing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'audio_editing',
    path: '/aanieditointi',
    name: 'AudioEditingSkillPage',
    schemaTitle: 'SkillSeoPage.audioEditingSchemaTitle',
    schemaDescription: 'SkillSeoPage.audioEditingSchemaDescription',
    heroPill: 'SkillSeoPage.audioEditingHeroPill',
    heroTitle: 'SkillSeoPage.audioEditingHeroTitle',
    heroSubtitle: 'SkillSeoPage.audioEditingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.audioEditingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.audioEditingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.audioEditingFaqQuestion1',
        answer: 'SkillSeoPage.audioEditingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.audioEditingFaqQuestion2',
        answer: 'SkillSeoPage.audioEditingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.audioEditingFaqQuestion3',
        answer: 'SkillSeoPage.audioEditingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'audio-mastering',
      'audio-mixing',
      'sound-design',
      'podcast-production',
      'voice-over',
    ],
  },
  {
    id: 'audio-mastering',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'audio_mastering',
    path: '/masterointi',
    name: 'AudioMasteringSkillPage',
    schemaTitle: 'SkillSeoPage.audioMasteringSchemaTitle',
    schemaDescription: 'SkillSeoPage.audioMasteringSchemaDescription',
    heroPill: 'SkillSeoPage.audioMasteringHeroPill',
    heroTitle: 'SkillSeoPage.audioMasteringHeroTitle',
    heroSubtitle: 'SkillSeoPage.audioMasteringHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.audioMasteringFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.audioMasteringFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.audioMasteringFaqQuestion1',
        answer: 'SkillSeoPage.audioMasteringFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.audioMasteringFaqQuestion2',
        answer: 'SkillSeoPage.audioMasteringFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.audioMasteringFaqQuestion3',
        answer: 'SkillSeoPage.audioMasteringFaqAnswer3',
      },
    ],
    relatedSkills: [
      'audio-mixing',
      'audio-editing',
      'sound-design',
      'podcast-production',
      'video-editing',
    ],
  },
  {
    id: 'audio-mixing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'audio_mixing',
    path: '/miksaus',
    name: 'AudioMixingSkillPage',
    schemaTitle: 'SkillSeoPage.audioMixingSchemaTitle',
    schemaDescription: 'SkillSeoPage.audioMixingSchemaDescription',
    heroPill: 'SkillSeoPage.audioMixingHeroPill',
    heroTitle: 'SkillSeoPage.audioMixingHeroTitle',
    heroSubtitle: 'SkillSeoPage.audioMixingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.audioMixingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.audioMixingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.audioMixingFaqQuestion1',
        answer: 'SkillSeoPage.audioMixingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.audioMixingFaqQuestion2',
        answer: 'SkillSeoPage.audioMixingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.audioMixingFaqQuestion3',
        answer: 'SkillSeoPage.audioMixingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'audio-mastering',
      'sound-design',
      'audio-editing',
      'ai-image-production',
      'video-editing',
    ],
  },
  {
    id: 'augmented-reality',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'augmented_reality',
    path: '/lisatty-todellisuus',
    name: 'AugmentedRealitySkillPage',
    schemaTitle: 'SkillSeoPage.augmentedRealitySchemaTitle',
    schemaDescription: 'SkillSeoPage.augmentedRealitySchemaDescription',
    heroPill: 'SkillSeoPage.augmentedRealityHeroPill',
    heroTitle: 'SkillSeoPage.augmentedRealityHeroTitle',
    heroSubtitle: 'SkillSeoPage.augmentedRealityHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.augmentedRealityFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.augmentedRealityFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.augmentedRealityFaqQuestion1',
        answer: 'SkillSeoPage.augmentedRealityFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.augmentedRealityFaqQuestion2',
        answer: 'SkillSeoPage.augmentedRealityFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.augmentedRealityFaqQuestion3',
        answer: 'SkillSeoPage.augmentedRealityFaqAnswer3',
      },
    ],
    relatedSkills: ['virtual-reality', 'arvr-content-creation', '3d-modeling', '3d-animation'],
  },
  {
    id: 'automations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'automations',
    path: '/digitaaliset-automaatiot',
    name: 'AutomationsSkillPage',
    schemaTitle: 'SkillSeoPage.automationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.automationsSchemaDescription',
    heroPill: 'SkillSeoPage.automationsHeroPill',
    heroTitle: 'SkillSeoPage.automationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.automationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.automationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.automationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.automationsFaqQuestion1',
        answer: 'SkillSeoPage.automationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.automationsFaqQuestion2',
        answer: 'SkillSeoPage.automationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.automationsFaqQuestion3',
        answer: 'SkillSeoPage.automationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'computer-vision',
      'ai-agent-development',
      'machine-learning',
      'system-architecture',
      'email-automation',
    ],
  },
  {
    id: 'b2b-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'b2b_marketing',
    path: '/b2b-markkinointi',
    name: 'B2bMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.b2bMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.b2bMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.b2bMarketingHeroPill',
    heroTitle: 'SkillSeoPage.b2bMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.b2bMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.b2bMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.b2bMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.b2bMarketingFaqQuestion1',
        answer: 'SkillSeoPage.b2bMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.b2bMarketingFaqQuestion2',
        answer: 'SkillSeoPage.b2bMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.b2bMarketingFaqQuestion3',
        answer: 'SkillSeoPage.b2bMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'inbound-marketing',
      'b2c-marketing',
      'growth-hacking',
      'lead-generation',
      'search-engine-marketing',
    ],
  },
  {
    id: 'b2b-sales',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'b2b_sales',
    path: '/b2b-myynti',
    name: 'B2bSalesSkillPage',
    schemaTitle: 'SkillSeoPage.b2bSalesSchemaTitle',
    schemaDescription: 'SkillSeoPage.b2bSalesSchemaDescription',
    heroPill: 'SkillSeoPage.b2bSalesHeroPill',
    heroTitle: 'SkillSeoPage.b2bSalesHeroTitle',
    heroSubtitle: 'SkillSeoPage.b2bSalesHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.b2bSalesFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.b2bSalesFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.b2bSalesFaqQuestion1',
        answer: 'SkillSeoPage.b2bSalesFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.b2bSalesFaqQuestion2',
        answer: 'SkillSeoPage.b2bSalesFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.b2bSalesFaqQuestion3',
        answer: 'SkillSeoPage.b2bSalesFaqAnswer3',
      },
    ],
    relatedSkills: [
      'recruitment',
      'lead-generation',
      'crm',
      'customer-oriented-development',
      'inbound-marketing',
    ],
  },
  {
    id: 'b2c-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'b2c_marketing',
    path: '/b2c-markkinointi',
    name: 'B2cMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.b2cMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.b2cMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.b2cMarketingHeroPill',
    heroTitle: 'SkillSeoPage.b2cMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.b2cMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.b2cMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.b2cMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.b2cMarketingFaqQuestion1',
        answer: 'SkillSeoPage.b2cMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.b2cMarketingFaqQuestion2',
        answer: 'SkillSeoPage.b2cMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.b2cMarketingFaqQuestion3',
        answer: 'SkillSeoPage.b2cMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'lifecycle-marketing',
      'b2b-marketing',
      'search-engine-marketing',
      'growth-hacking',
      'inbound-marketing',
    ],
  },
  {
    id: 'back-end-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'back_end_development',
    path: '/backend-kehitys',
    name: 'BackEndDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.backEndDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.backEndDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.backEndDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.backEndDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.backEndDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.backEndDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.backEndDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.backEndDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.backEndDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.backEndDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.backEndDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.backEndDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.backEndDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'api-development',
      'cross-platform-development',
      'mobile-app-development',
      'front-end-development',
      'application-architecture',
    ],
  },
  {
    id: 'big-data',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'big_data',
    path: '/big-data',
    name: 'BigDataSkillPage',
    schemaTitle: 'SkillSeoPage.bigDataSchemaTitle',
    schemaDescription: 'SkillSeoPage.bigDataSchemaDescription',
    heroPill: 'SkillSeoPage.bigDataHeroPill',
    heroTitle: 'SkillSeoPage.bigDataHeroTitle',
    heroSubtitle: 'SkillSeoPage.bigDataHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.bigDataFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.bigDataFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.bigDataFaqQuestion1',
        answer: 'SkillSeoPage.bigDataFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.bigDataFaqQuestion2',
        answer: 'SkillSeoPage.bigDataFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.bigDataFaqQuestion3',
        answer: 'SkillSeoPage.bigDataFaqAnswer3',
      },
    ],
    relatedSkills: ['data-science', 'crm', 'neural-networks', 'deep-learning', 'machine-learning'],
  },
  {
    id: 'blog-writing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'blog_writing',
    path: '/blogikirjoitukset',
    name: 'BlogWritingSkillPage',
    schemaTitle: 'SkillSeoPage.blogWritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.blogWritingSchemaDescription',
    heroPill: 'SkillSeoPage.blogWritingHeroPill',
    heroTitle: 'SkillSeoPage.blogWritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.blogWritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.blogWritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.blogWritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.blogWritingFaqQuestion1',
        answer: 'SkillSeoPage.blogWritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.blogWritingFaqQuestion2',
        answer: 'SkillSeoPage.blogWritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.blogWritingFaqQuestion3',
        answer: 'SkillSeoPage.blogWritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'product-description-writing',
      'article-writing',
      'seo-writing',
      'media-relations',
    ],
  },
  {
    id: 'book-cover-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'book_cover_design',
    path: '/kirjan-kannen-suunnittelu',
    name: 'BookCoverDesignSkillPage',
    schemaTitle: 'SkillSeoPage.bookCoverDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.bookCoverDesignSchemaDescription',
    heroPill: 'SkillSeoPage.bookCoverDesignHeroPill',
    heroTitle: 'SkillSeoPage.bookCoverDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.bookCoverDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.bookCoverDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.bookCoverDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.bookCoverDesignFaqQuestion1',
        answer: 'SkillSeoPage.bookCoverDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.bookCoverDesignFaqQuestion2',
        answer: 'SkillSeoPage.bookCoverDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.bookCoverDesignFaqQuestion3',
        answer: 'SkillSeoPage.bookCoverDesignFaqAnswer3',
      },
    ],
    relatedSkills: ['book-layout', 'drawing', 'ad-creatives', 'motion-graphics', 'vector-design'],
  },
  {
    id: 'book-layout',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'book_layout',
    path: '/taitto',
    name: 'BookLayoutSkillPage',
    schemaTitle: 'SkillSeoPage.bookLayoutSchemaTitle',
    schemaDescription: 'SkillSeoPage.bookLayoutSchemaDescription',
    heroPill: 'SkillSeoPage.bookLayoutHeroPill',
    heroTitle: 'SkillSeoPage.bookLayoutHeroTitle',
    heroSubtitle: 'SkillSeoPage.bookLayoutHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.bookLayoutFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.bookLayoutFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.bookLayoutFaqQuestion1',
        answer: 'SkillSeoPage.bookLayoutFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.bookLayoutFaqQuestion2',
        answer: 'SkillSeoPage.bookLayoutFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.bookLayoutFaqQuestion3',
        answer: 'SkillSeoPage.bookLayoutFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-cover-design',
      'drawing',
      'infographics',
      'motion-graphics',
      'ad-creatives',
    ],
  },
  {
    id: 'brand-consultation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_consultation',
    path: '/brandikonsultointi',
    name: 'BrandConsultationSkillPage',
    schemaTitle: 'SkillSeoPage.brandConsultationSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandConsultationSchemaDescription',
    heroPill: 'SkillSeoPage.brandConsultationHeroPill',
    heroTitle: 'SkillSeoPage.brandConsultationHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandConsultationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandConsultationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandConsultationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandConsultationFaqQuestion1',
        answer: 'SkillSeoPage.brandConsultationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandConsultationFaqQuestion2',
        answer: 'SkillSeoPage.brandConsultationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandConsultationFaqQuestion3',
        answer: 'SkillSeoPage.brandConsultationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-strategy',
      'brand-management',
      'concept-development',
      'employer-branding',
      'brand-development',
    ],
  },
  {
    id: 'brand-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_development',
    path: '/brandin-kehittaminen',
    name: 'BrandDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.brandDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.brandDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.brandDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.brandDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.brandDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.brandDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-research',
      'brand-management',
      'brand-consultation',
      'brand-strategy',
      'concept-art',
    ],
  },
  {
    id: 'brand-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_management',
    path: '/brandin-hallinta',
    name: 'BrandManagementSkillPage',
    schemaTitle: 'SkillSeoPage.brandManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandManagementSchemaDescription',
    heroPill: 'SkillSeoPage.brandManagementHeroPill',
    heroTitle: 'SkillSeoPage.brandManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandManagementFaqQuestion1',
        answer: 'SkillSeoPage.brandManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandManagementFaqQuestion2',
        answer: 'SkillSeoPage.brandManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandManagementFaqQuestion3',
        answer: 'SkillSeoPage.brandManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-research',
      'brand-strategy',
      'brand-consultation',
      'public-relations',
      'drawing',
    ],
  },
  {
    id: 'brand-partnership',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_partnership',
    path: '/brandiyhteistyot',
    name: 'BrandPartnershipSkillPage',
    schemaTitle: 'SkillSeoPage.brandPartnershipSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandPartnershipSchemaDescription',
    heroPill: 'SkillSeoPage.brandPartnershipHeroPill',
    heroTitle: 'SkillSeoPage.brandPartnershipHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandPartnershipHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandPartnershipFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandPartnershipFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandPartnershipFaqQuestion1',
        answer: 'SkillSeoPage.brandPartnershipFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandPartnershipFaqQuestion2',
        answer: 'SkillSeoPage.brandPartnershipFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandPartnershipFaqQuestion3',
        answer: 'SkillSeoPage.brandPartnershipFaqAnswer3',
      },
    ],
    relatedSkills: [
      'public-relations',
      'influencer-marketing',
      'user-generated-content',
      'brand-management',
      'commercial-photography',
    ],
  },
  {
    id: 'brand-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_research',
    path: '/branditutkimus',
    name: 'BrandResearchSkillPage',
    schemaTitle: 'SkillSeoPage.brandResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandResearchSchemaDescription',
    heroPill: 'SkillSeoPage.brandResearchHeroPill',
    heroTitle: 'SkillSeoPage.brandResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandResearchFaqQuestion1',
        answer: 'SkillSeoPage.brandResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandResearchFaqQuestion2',
        answer: 'SkillSeoPage.brandResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandResearchFaqQuestion3',
        answer: 'SkillSeoPage.brandResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-management',
      'brand-strategy',
      'brand-development',
      'branding',
      'website-design',
    ],
  },
  {
    id: 'brand-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brand_strategy',
    path: '/brandistrategia',
    name: 'BrandStrategySkillPage',
    schemaTitle: 'SkillSeoPage.brandStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.brandStrategySchemaDescription',
    heroPill: 'SkillSeoPage.brandStrategyHeroPill',
    heroTitle: 'SkillSeoPage.brandStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandStrategyFaqQuestion1',
        answer: 'SkillSeoPage.brandStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandStrategyFaqQuestion2',
        answer: 'SkillSeoPage.brandStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandStrategyFaqQuestion3',
        answer: 'SkillSeoPage.brandStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-research',
      'media-strategy',
      'brand-consultation',
      'brand-management',
      'content-strategy',
    ],
  },
  {
    id: 'branding',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'branding',
    path: '/brandays',
    name: 'BrandingSkillPage',
    schemaTitle: 'SkillSeoPage.brandingSchemaTitle',
    schemaDescription: 'SkillSeoPage.brandingSchemaDescription',
    heroPill: 'SkillSeoPage.brandingHeroPill',
    heroTitle: 'SkillSeoPage.brandingHeroTitle',
    heroSubtitle: 'SkillSeoPage.brandingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brandingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brandingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brandingFaqQuestion1',
        answer: 'SkillSeoPage.brandingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brandingFaqQuestion2',
        answer: 'SkillSeoPage.brandingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brandingFaqQuestion3',
        answer: 'SkillSeoPage.brandingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'packaging-design',
      'book-cover-design',
      'vector-design',
      'motion-graphics',
      'book-layout',
    ],
  },
  {
    id: 'brochure-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'brochure_design',
    path: '/esitteen-suunnittelu',
    name: 'BrochureDesignSkillPage',
    schemaTitle: 'SkillSeoPage.brochureDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.brochureDesignSchemaDescription',
    heroPill: 'SkillSeoPage.brochureDesignHeroPill',
    heroTitle: 'SkillSeoPage.brochureDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.brochureDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.brochureDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.brochureDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.brochureDesignFaqQuestion1',
        answer: 'SkillSeoPage.brochureDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.brochureDesignFaqQuestion2',
        answer: 'SkillSeoPage.brochureDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.brochureDesignFaqQuestion3',
        answer: 'SkillSeoPage.brochureDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'vector-design',
      'book-layout',
      'business-card-design',
      'infographics',
      'flyer-design',
    ],
  },
  {
    id: 'business-card-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'business_card_design',
    path: '/kayntikortin-suunnittelu',
    name: 'BusinessCardDesignSkillPage',
    schemaTitle: 'SkillSeoPage.businessCardDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.businessCardDesignSchemaDescription',
    heroPill: 'SkillSeoPage.businessCardDesignHeroPill',
    heroTitle: 'SkillSeoPage.businessCardDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.businessCardDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.businessCardDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.businessCardDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.businessCardDesignFaqQuestion1',
        answer: 'SkillSeoPage.businessCardDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.businessCardDesignFaqQuestion2',
        answer: 'SkillSeoPage.businessCardDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.businessCardDesignFaqQuestion3',
        answer: 'SkillSeoPage.businessCardDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'vector-design',
      'flyer-design',
      'packaging-design',
      'brochure-design',
      'poster-design',
    ],
  },
  {
    id: 'cad',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'cad',
    path: '/cad',
    name: 'CadSkillPage',
    schemaTitle: 'SkillSeoPage.cadSchemaTitle',
    schemaDescription: 'SkillSeoPage.cadSchemaDescription',
    heroPill: 'SkillSeoPage.cadHeroPill',
    heroTitle: 'SkillSeoPage.cadHeroTitle',
    heroSubtitle: 'SkillSeoPage.cadHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.cadFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.cadFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.cadFaqQuestion1',
        answer: 'SkillSeoPage.cadFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.cadFaqQuestion2',
        answer: 'SkillSeoPage.cadFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.cadFaqQuestion3',
        answer: 'SkillSeoPage.cadFaqAnswer3',
      },
    ],
    relatedSkills: [
      '3d-rendering',
      '3d-design',
      '3d-modeling',
      'brochure-design',
      'packaging-design',
    ],
  },
  {
    id: 'character-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'character_design',
    path: '/hahmosuunnittelu',
    name: 'CharacterDesignSkillPage',
    schemaTitle: 'SkillSeoPage.characterDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.characterDesignSchemaDescription',
    heroPill: 'SkillSeoPage.characterDesignHeroPill',
    heroTitle: 'SkillSeoPage.characterDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.characterDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.characterDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.characterDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.characterDesignFaqQuestion1',
        answer: 'SkillSeoPage.characterDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.characterDesignFaqQuestion2',
        answer: 'SkillSeoPage.characterDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.characterDesignFaqQuestion3',
        answer: 'SkillSeoPage.characterDesignFaqAnswer3',
      },
    ],
    relatedSkills: ['concept-art', 'drawing', '2d-animation', '3d-animation', 'vector-design'],
  },
  {
    id: 'commercial-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'commercial_photography',
    path: '/mainosvalokuvaus',
    name: 'CommercialPhotographySkillPage',
    schemaTitle: 'SkillSeoPage.commercialPhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.commercialPhotographySchemaDescription',
    heroPill: 'SkillSeoPage.commercialPhotographyHeroPill',
    heroTitle: 'SkillSeoPage.commercialPhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.commercialPhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.commercialPhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.commercialPhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.commercialPhotographyFaqQuestion1',
        answer: 'SkillSeoPage.commercialPhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.commercialPhotographyFaqQuestion2',
        answer: 'SkillSeoPage.commercialPhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.commercialPhotographyFaqQuestion3',
        answer: 'SkillSeoPage.commercialPhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'studio-photography',
      'real-estate-photography',
      'portrait-photography',
      'event-photography',
      'drone-videography',
    ],
  },
  {
    id: 'commercial-videos',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'commercial_videos',
    path: '/mainosvideot',
    name: 'CommercialVideosSkillPage',
    schemaTitle: 'SkillSeoPage.commercialVideosSchemaTitle',
    schemaDescription: 'SkillSeoPage.commercialVideosSchemaDescription',
    heroPill: 'SkillSeoPage.commercialVideosHeroPill',
    heroTitle: 'SkillSeoPage.commercialVideosHeroTitle',
    heroSubtitle: 'SkillSeoPage.commercialVideosHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.commercialVideosFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.commercialVideosFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.commercialVideosFaqQuestion1',
        answer: 'SkillSeoPage.commercialVideosFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.commercialVideosFaqQuestion2',
        answer: 'SkillSeoPage.commercialVideosFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.commercialVideosFaqQuestion3',
        answer: 'SkillSeoPage.commercialVideosFaqAnswer3',
      },
    ],
    relatedSkills: [
      'corporate-video-production',
      'video-effects',
      'drone-videography',
      'short-form-video-production',
      'videography',
    ],
  },
  {
    id: 'communication-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'communication_strategy',
    path: '/viestintastrategia',
    name: 'CommunicationStrategySkillPage',
    schemaTitle: 'SkillSeoPage.communicationStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.communicationStrategySchemaDescription',
    heroPill: 'SkillSeoPage.communicationStrategyHeroPill',
    heroTitle: 'SkillSeoPage.communicationStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.communicationStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.communicationStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.communicationStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.communicationStrategyFaqQuestion1',
        answer: 'SkillSeoPage.communicationStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.communicationStrategyFaqQuestion2',
        answer: 'SkillSeoPage.communicationStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.communicationStrategyFaqQuestion3',
        answer: 'SkillSeoPage.communicationStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'crisis-management',
      'media-relations',
      'internal-communication',
      'public-relations',
      'employer-branding',
    ],
  },
  {
    id: 'computer-vision',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'computer_vision',
    path: '/tietokonenako',
    name: 'ComputerVisionSkillPage',
    schemaTitle: 'SkillSeoPage.computerVisionSchemaTitle',
    schemaDescription: 'SkillSeoPage.computerVisionSchemaDescription',
    heroPill: 'SkillSeoPage.computerVisionHeroPill',
    heroTitle: 'SkillSeoPage.computerVisionHeroTitle',
    heroSubtitle: 'SkillSeoPage.computerVisionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.computerVisionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.computerVisionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.computerVisionFaqQuestion1',
        answer: 'SkillSeoPage.computerVisionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.computerVisionFaqQuestion2',
        answer: 'SkillSeoPage.computerVisionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.computerVisionFaqQuestion3',
        answer: 'SkillSeoPage.computerVisionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'machine-learning',
      'automations',
      'neural-networks',
      'deep-learning',
      'big-data',
    ],
  },
  {
    id: 'concept-art',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'concept_art',
    path: '/konseptitaide',
    name: 'ConceptArtSkillPage',
    schemaTitle: 'SkillSeoPage.conceptArtSchemaTitle',
    schemaDescription: 'SkillSeoPage.conceptArtSchemaDescription',
    heroPill: 'SkillSeoPage.conceptArtHeroPill',
    heroTitle: 'SkillSeoPage.conceptArtHeroTitle',
    heroSubtitle: 'SkillSeoPage.conceptArtHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.conceptArtFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.conceptArtFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.conceptArtFaqQuestion1',
        answer: 'SkillSeoPage.conceptArtFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.conceptArtFaqQuestion2',
        answer: 'SkillSeoPage.conceptArtFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.conceptArtFaqQuestion3',
        answer: 'SkillSeoPage.conceptArtFaqAnswer3',
      },
    ],
    relatedSkills: [
      'character-design',
      '2d-animation',
      'illustration',
      'infographics',
      'poster-design',
    ],
  },
  {
    id: 'concept-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'concept_development',
    path: '/konseptikehitys',
    name: 'ConceptDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.conceptDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.conceptDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.conceptDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.conceptDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.conceptDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.conceptDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.conceptDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.conceptDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.conceptDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.conceptDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.conceptDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.conceptDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.conceptDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'service-development',
      'service-design',
      'customer-oriented-development',
      'brand-consultation',
      'mobile-app-design',
    ],
  },
  {
    id: 'consumer-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'consumer_research',
    path: '/kuluttajatutkimus',
    name: 'ConsumerResearchSkillPage',
    schemaTitle: 'SkillSeoPage.consumerResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.consumerResearchSchemaDescription',
    heroPill: 'SkillSeoPage.consumerResearchHeroPill',
    heroTitle: 'SkillSeoPage.consumerResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.consumerResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.consumerResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.consumerResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.consumerResearchFaqQuestion1',
        answer: 'SkillSeoPage.consumerResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.consumerResearchFaqQuestion2',
        answer: 'SkillSeoPage.consumerResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.consumerResearchFaqQuestion3',
        answer: 'SkillSeoPage.consumerResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'market-research',
      'market-segmentation',
      'target-group-research',
      'brand-research',
      'user-research',
    ],
  },
  {
    id: 'content-creation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'content_creation',
    path: '/sisallontuotanto',
    name: 'ContentCreationSkillPage',
    schemaTitle: 'SkillSeoPage.contentCreationSchemaTitle',
    schemaDescription: 'SkillSeoPage.contentCreationSchemaDescription',
    heroPill: 'SkillSeoPage.contentCreationHeroPill',
    heroTitle: 'SkillSeoPage.contentCreationHeroTitle',
    heroSubtitle: 'SkillSeoPage.contentCreationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.contentCreationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.contentCreationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.contentCreationFaqQuestion1',
        answer: 'SkillSeoPage.contentCreationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.contentCreationFaqQuestion2',
        answer: 'SkillSeoPage.contentCreationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.contentCreationFaqQuestion3',
        answer: 'SkillSeoPage.contentCreationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'content-strategy',
      'user-generated-content',
      'scriptwriting',
      'crisis-management',
    ],
  },
  {
    id: 'content-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'content_marketing',
    path: '/sisaltomarkkinointi',
    name: 'ContentMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.contentMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.contentMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.contentMarketingHeroPill',
    heroTitle: 'SkillSeoPage.contentMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.contentMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.contentMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.contentMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.contentMarketingFaqQuestion1',
        answer: 'SkillSeoPage.contentMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.contentMarketingFaqQuestion2',
        answer: 'SkillSeoPage.contentMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.contentMarketingFaqQuestion3',
        answer: 'SkillSeoPage.contentMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'content-strategy',
      'ghostwriting',
      'inbound-marketing',
      'accessible-content',
      'scriptwriting',
    ],
  },
  {
    id: 'content-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'content_strategy',
    path: '/sisaltostrategia',
    name: 'ContentStrategySkillPage',
    schemaTitle: 'SkillSeoPage.contentStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.contentStrategySchemaDescription',
    heroPill: 'SkillSeoPage.contentStrategyHeroPill',
    heroTitle: 'SkillSeoPage.contentStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.contentStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.contentStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.contentStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.contentStrategyFaqQuestion1',
        answer: 'SkillSeoPage.contentStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.contentStrategyFaqQuestion2',
        answer: 'SkillSeoPage.contentStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.contentStrategyFaqQuestion3',
        answer: 'SkillSeoPage.contentStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'public-relations',
      'social-media-strategy',
      'brand-strategy',
      'short-form-video-production',
    ],
  },
  {
    id: 'conversion-rate-optimization',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'conversion_rate_optimization',
    path: '/konversio-optimointi',
    name: 'ConversionRateOptimizationSkillPage',
    schemaTitle: 'SkillSeoPage.conversionRateOptimizationSchemaTitle',
    schemaDescription: 'SkillSeoPage.conversionRateOptimizationSchemaDescription',
    heroPill: 'SkillSeoPage.conversionRateOptimizationHeroPill',
    heroTitle: 'SkillSeoPage.conversionRateOptimizationHeroTitle',
    heroSubtitle: 'SkillSeoPage.conversionRateOptimizationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.conversionRateOptimizationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.conversionRateOptimizationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.conversionRateOptimizationFaqQuestion1',
        answer: 'SkillSeoPage.conversionRateOptimizationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.conversionRateOptimizationFaqQuestion2',
        answer: 'SkillSeoPage.conversionRateOptimizationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.conversionRateOptimizationFaqQuestion3',
        answer: 'SkillSeoPage.conversionRateOptimizationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'growth-hacking',
      'cookie-management',
      'web-analytics',
      'ab-testing',
      'search-engine-marketing',
    ],
  },
  {
    id: 'conversion-tracking',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'conversion_tracking',
    path: '/konversioseuranta',
    name: 'ConversionTrackingSkillPage',
    schemaTitle: 'SkillSeoPage.conversionTrackingSchemaTitle',
    schemaDescription: 'SkillSeoPage.conversionTrackingSchemaDescription',
    heroPill: 'SkillSeoPage.conversionTrackingHeroPill',
    heroTitle: 'SkillSeoPage.conversionTrackingHeroTitle',
    heroSubtitle: 'SkillSeoPage.conversionTrackingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.conversionTrackingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.conversionTrackingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.conversionTrackingFaqQuestion1',
        answer: 'SkillSeoPage.conversionTrackingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.conversionTrackingFaqQuestion2',
        answer: 'SkillSeoPage.conversionTrackingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.conversionTrackingFaqQuestion3',
        answer: 'SkillSeoPage.conversionTrackingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'data-analytics',
      'web-analytics',
      'conversion-rate-optimization',
      'ab-testing',
    ],
  },
  {
    id: 'cookie-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'cookie_management',
    path: '/evasteiden-hallinta',
    name: 'CookieManagementSkillPage',
    schemaTitle: 'SkillSeoPage.cookieManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.cookieManagementSchemaDescription',
    heroPill: 'SkillSeoPage.cookieManagementHeroPill',
    heroTitle: 'SkillSeoPage.cookieManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.cookieManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.cookieManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.cookieManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.cookieManagementFaqQuestion1',
        answer: 'SkillSeoPage.cookieManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.cookieManagementFaqQuestion2',
        answer: 'SkillSeoPage.cookieManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.cookieManagementFaqQuestion3',
        answer: 'SkillSeoPage.cookieManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'web-analytics',
      'conversion-rate-optimization',
      'e-commerce-development',
      'seo',
      'digital-marketing',
    ],
  },
  {
    id: 'copywriting',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'copywriting',
    path: '/copywriting',
    name: 'CopywritingSkillPage',
    schemaTitle: 'SkillSeoPage.copywritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.copywritingSchemaDescription',
    heroPill: 'SkillSeoPage.copywritingHeroPill',
    heroTitle: 'SkillSeoPage.copywritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.copywritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.copywritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.copywritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.copywritingFaqQuestion1',
        answer: 'SkillSeoPage.copywritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.copywritingFaqQuestion2',
        answer: 'SkillSeoPage.copywritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.copywritingFaqQuestion3',
        answer: 'SkillSeoPage.copywritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'accessible-content',
      'ux-writing',
      'content-strategy',
      'scriptwriting',
    ],
  },
  {
    id: 'corporate-identity',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'corporate_identity',
    path: '/yritysilme',
    name: 'CorporateIdentitySkillPage',
    schemaTitle: 'SkillSeoPage.corporateIdentitySchemaTitle',
    schemaDescription: 'SkillSeoPage.corporateIdentitySchemaDescription',
    heroPill: 'SkillSeoPage.corporateIdentityHeroPill',
    heroTitle: 'SkillSeoPage.corporateIdentityHeroTitle',
    heroSubtitle: 'SkillSeoPage.corporateIdentityHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.corporateIdentityFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.corporateIdentityFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.corporateIdentityFaqQuestion1',
        answer: 'SkillSeoPage.corporateIdentityFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.corporateIdentityFaqQuestion2',
        answer: 'SkillSeoPage.corporateIdentityFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.corporateIdentityFaqQuestion3',
        answer: 'SkillSeoPage.corporateIdentityFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-layout',
      'packaging-design',
      'book-cover-design',
      'vector-design',
      'print-design',
    ],
  },
  {
    id: 'corporate-video-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'corporate_video_production',
    path: '/yritysvideot',
    name: 'CorporateVideoProductionSkillPage',
    schemaTitle: 'SkillSeoPage.corporateVideoProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.corporateVideoProductionSchemaDescription',
    heroPill: 'SkillSeoPage.corporateVideoProductionHeroPill',
    heroTitle: 'SkillSeoPage.corporateVideoProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.corporateVideoProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.corporateVideoProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.corporateVideoProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.corporateVideoProductionFaqQuestion1',
        answer: 'SkillSeoPage.corporateVideoProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.corporateVideoProductionFaqQuestion2',
        answer: 'SkillSeoPage.corporateVideoProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.corporateVideoProductionFaqQuestion3',
        answer: 'SkillSeoPage.corporateVideoProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'video-effects',
      'commercial-videos',
      'short-form-video-production',
      'video-production',
      'videography',
    ],
  },
  {
    id: 'crisis-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'crisis_management',
    path: '/kriisiviestinta',
    name: 'CrisisManagementSkillPage',
    schemaTitle: 'SkillSeoPage.crisisManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.crisisManagementSchemaDescription',
    heroPill: 'SkillSeoPage.crisisManagementHeroPill',
    heroTitle: 'SkillSeoPage.crisisManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.crisisManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.crisisManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.crisisManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.crisisManagementFaqQuestion1',
        answer: 'SkillSeoPage.crisisManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.crisisManagementFaqQuestion2',
        answer: 'SkillSeoPage.crisisManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.crisisManagementFaqQuestion3',
        answer: 'SkillSeoPage.crisisManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'media-relations',
      'internal-communication',
      'communication-strategy',
      'article-writing',
      'b2b-marketing',
    ],
  },
  {
    id: 'crm',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'crm',
    path: '/crm',
    name: 'CrmSkillPage',
    schemaTitle: 'SkillSeoPage.crmSchemaTitle',
    schemaDescription: 'SkillSeoPage.crmSchemaDescription',
    heroPill: 'SkillSeoPage.crmHeroPill',
    heroTitle: 'SkillSeoPage.crmHeroTitle',
    heroSubtitle: 'SkillSeoPage.crmHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.crmFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.crmFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.crmFaqQuestion1',
        answer: 'SkillSeoPage.crmFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.crmFaqQuestion2',
        answer: 'SkillSeoPage.crmFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.crmFaqQuestion3',
        answer: 'SkillSeoPage.crmFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-operations',
      'financial-controlling',
      'big-data',
      'service-development',
      'marketing-automation',
    ],
  },
  {
    id: 'cross-platform-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'cross_platform_development',
    path: '/cross-platform-kehitys',
    name: 'CrossPlatformDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.crossPlatformDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.crossPlatformDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.crossPlatformDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.crossPlatformDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.crossPlatformDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.crossPlatformDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.crossPlatformDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.crossPlatformDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.crossPlatformDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.crossPlatformDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.crossPlatformDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.crossPlatformDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.crossPlatformDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'android-development',
      'database-management',
      'api-development',
      'back-end-development',
      'front-end-development',
    ],
  },
  {
    id: 'customer-oriented-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'customer_oriented_development',
    path: '/asiakaslahtoinen-kehitys',
    name: 'CustomerOrientedDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.customerOrientedDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.customerOrientedDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.customerOrientedDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.customerOrientedDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.customerOrientedDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.customerOrientedDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.customerOrientedDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.customerOrientedDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.customerOrientedDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.customerOrientedDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.customerOrientedDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.customerOrientedDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.customerOrientedDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'service-development',
      'service-design',
      'user-interface-testing',
      'usability-testing',
      'concept-development',
    ],
  },
  {
    id: 'data-analytics',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'data_analytics',
    path: '/data-analytiikka',
    name: 'DataAnalyticsSkillPage',
    schemaTitle: 'SkillSeoPage.dataAnalyticsSchemaTitle',
    schemaDescription: 'SkillSeoPage.dataAnalyticsSchemaDescription',
    heroPill: 'SkillSeoPage.dataAnalyticsHeroPill',
    heroTitle: 'SkillSeoPage.dataAnalyticsHeroTitle',
    heroSubtitle: 'SkillSeoPage.dataAnalyticsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.dataAnalyticsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.dataAnalyticsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.dataAnalyticsFaqQuestion1',
        answer: 'SkillSeoPage.dataAnalyticsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.dataAnalyticsFaqQuestion2',
        answer: 'SkillSeoPage.dataAnalyticsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.dataAnalyticsFaqQuestion3',
        answer: 'SkillSeoPage.dataAnalyticsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'data-science',
      'e-commerce-development',
      'b2c-marketing',
      'digital-marketing',
      'web-analytics',
    ],
  },
  {
    id: 'data-entry',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'data_entry',
    path: '/data-entry',
    name: 'DataEntrySkillPage',
    schemaTitle: 'SkillSeoPage.dataEntrySchemaTitle',
    schemaDescription: 'SkillSeoPage.dataEntrySchemaDescription',
    heroPill: 'SkillSeoPage.dataEntryHeroPill',
    heroTitle: 'SkillSeoPage.dataEntryHeroTitle',
    heroSubtitle: 'SkillSeoPage.dataEntryHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.dataEntryFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.dataEntryFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.dataEntryFaqQuestion1',
        answer: 'SkillSeoPage.dataEntryFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.dataEntryFaqQuestion2',
        answer: 'SkillSeoPage.dataEntryFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.dataEntryFaqQuestion3',
        answer: 'SkillSeoPage.dataEntryFaqAnswer3',
      },
    ],
    relatedSkills: [
      'recruitment',
      'transcription',
      'data-science',
      'virtual-assistance',
      'database-management',
    ],
  },
  {
    id: 'data-science',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'data_science',
    path: '/data-science',
    name: 'DataScienceSkillPage',
    schemaTitle: 'SkillSeoPage.dataScienceSchemaTitle',
    schemaDescription: 'SkillSeoPage.dataScienceSchemaDescription',
    heroPill: 'SkillSeoPage.dataScienceHeroPill',
    heroTitle: 'SkillSeoPage.dataScienceHeroTitle',
    heroSubtitle: 'SkillSeoPage.dataScienceHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.dataScienceFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.dataScienceFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.dataScienceFaqQuestion1',
        answer: 'SkillSeoPage.dataScienceFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.dataScienceFaqQuestion2',
        answer: 'SkillSeoPage.dataScienceFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.dataScienceFaqQuestion3',
        answer: 'SkillSeoPage.dataScienceFaqAnswer3',
      },
    ],
    relatedSkills: [
      'data-analytics',
      'big-data',
      'machine-learning',
      'database-management',
      'data-entry',
    ],
  },
  {
    id: 'database-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'database_management',
    path: '/tietokannanhallinta',
    name: 'DatabaseManagementSkillPage',
    schemaTitle: 'SkillSeoPage.databaseManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.databaseManagementSchemaDescription',
    heroPill: 'SkillSeoPage.databaseManagementHeroPill',
    heroTitle: 'SkillSeoPage.databaseManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.databaseManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.databaseManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.databaseManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.databaseManagementFaqQuestion1',
        answer: 'SkillSeoPage.databaseManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.databaseManagementFaqQuestion2',
        answer: 'SkillSeoPage.databaseManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.databaseManagementFaqQuestion3',
        answer: 'SkillSeoPage.databaseManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'cross-platform-development',
      'application-architecture',
      'api-development',
      'machine-learning',
      'mobile-app-development',
    ],
  },
  {
    id: 'deep-learning',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'deep_learning',
    path: '/syvaoppiminen',
    name: 'DeepLearningSkillPage',
    schemaTitle: 'SkillSeoPage.deepLearningSchemaTitle',
    schemaDescription: 'SkillSeoPage.deepLearningSchemaDescription',
    heroPill: 'SkillSeoPage.deepLearningHeroPill',
    heroTitle: 'SkillSeoPage.deepLearningHeroTitle',
    heroSubtitle: 'SkillSeoPage.deepLearningHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.deepLearningFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.deepLearningFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.deepLearningFaqQuestion1',
        answer: 'SkillSeoPage.deepLearningFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.deepLearningFaqQuestion2',
        answer: 'SkillSeoPage.deepLearningFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.deepLearningFaqQuestion3',
        answer: 'SkillSeoPage.deepLearningFaqAnswer3',
      },
    ],
    relatedSkills: [
      'machine-learning',
      'ai-development',
      'neural-networks',
      'computer-vision',
      'big-data',
    ],
  },
  {
    id: 'digital-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'digital_marketing',
    path: '/digitaalinen-markkinointi',
    name: 'DigitalMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.digitalMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.digitalMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.digitalMarketingHeroPill',
    heroTitle: 'SkillSeoPage.digitalMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.digitalMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.digitalMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.digitalMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.digitalMarketingFaqQuestion1',
        answer: 'SkillSeoPage.digitalMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.digitalMarketingFaqQuestion2',
        answer: 'SkillSeoPage.digitalMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.digitalMarketingFaqQuestion3',
        answer: 'SkillSeoPage.digitalMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'search-engine-marketing',
      'lifecycle-marketing',
      'growth-hacking',
      'inbound-marketing',
      'marketing-strategy',
    ],
  },
  {
    id: 'drawing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'drawing',
    path: '/piirtaminen',
    name: 'DrawingSkillPage',
    schemaTitle: 'SkillSeoPage.drawingSchemaTitle',
    schemaDescription: 'SkillSeoPage.drawingSchemaDescription',
    heroPill: 'SkillSeoPage.drawingHeroPill',
    heroTitle: 'SkillSeoPage.drawingHeroTitle',
    heroSubtitle: 'SkillSeoPage.drawingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.drawingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.drawingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.drawingFaqQuestion1',
        answer: 'SkillSeoPage.drawingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.drawingFaqQuestion2',
        answer: 'SkillSeoPage.drawingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.drawingFaqQuestion3',
        answer: 'SkillSeoPage.drawingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-cover-design',
      'character-design',
      'book-layout',
      'vector-design',
      'ad-creatives',
    ],
  },
  {
    id: 'drone-videography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'drone_videography',
    path: '/drone-kuvaus',
    name: 'DroneVideographySkillPage',
    schemaTitle: 'SkillSeoPage.droneVideographySchemaTitle',
    schemaDescription: 'SkillSeoPage.droneVideographySchemaDescription',
    heroPill: 'SkillSeoPage.droneVideographyHeroPill',
    heroTitle: 'SkillSeoPage.droneVideographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.droneVideographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.droneVideographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.droneVideographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.droneVideographyFaqQuestion1',
        answer: 'SkillSeoPage.droneVideographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.droneVideographyFaqQuestion2',
        answer: 'SkillSeoPage.droneVideographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.droneVideographyFaqQuestion3',
        answer: 'SkillSeoPage.droneVideographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'real-estate-photography',
      'videography',
      'commercial-videos',
      'landscape-photography',
      'studio-photography',
    ],
  },
  {
    id: 'e-commerce-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'e_commerce_design',
    path: '/verkkokaupan-suunnittelu',
    name: 'ECommerceDesignSkillPage',
    schemaTitle: 'SkillSeoPage.eCommerceDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.eCommerceDesignSchemaDescription',
    heroPill: 'SkillSeoPage.eCommerceDesignHeroPill',
    heroTitle: 'SkillSeoPage.eCommerceDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.eCommerceDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.eCommerceDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.eCommerceDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.eCommerceDesignFaqQuestion1',
        answer: 'SkillSeoPage.eCommerceDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.eCommerceDesignFaqQuestion2',
        answer: 'SkillSeoPage.eCommerceDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.eCommerceDesignFaqQuestion3',
        answer: 'SkillSeoPage.eCommerceDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'e-commerce-development',
      'mobile-app-design',
      'user-research',
      'ui-design',
      'conversion-rate-optimization',
    ],
  },
  {
    id: 'e-commerce-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'e_commerce_development',
    path: '/verkkokaupan-kehittaminen',
    name: 'ECommerceDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.eCommerceDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.eCommerceDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.eCommerceDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.eCommerceDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.eCommerceDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.eCommerceDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.eCommerceDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.eCommerceDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.eCommerceDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.eCommerceDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.eCommerceDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.eCommerceDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.eCommerceDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'cookie-management',
      'e-commerce-design',
      'growth-hacking',
      'data-analytics',
      'conversion-rate-optimization',
    ],
  },
  {
    id: 'email-automation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'email_automation',
    path: '/sahkopostiautomaatio',
    name: 'EmailAutomationSkillPage',
    schemaTitle: 'SkillSeoPage.emailAutomationSchemaTitle',
    schemaDescription: 'SkillSeoPage.emailAutomationSchemaDescription',
    heroPill: 'SkillSeoPage.emailAutomationHeroPill',
    heroTitle: 'SkillSeoPage.emailAutomationHeroTitle',
    heroSubtitle: 'SkillSeoPage.emailAutomationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.emailAutomationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.emailAutomationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.emailAutomationFaqQuestion1',
        answer: 'SkillSeoPage.emailAutomationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.emailAutomationFaqQuestion2',
        answer: 'SkillSeoPage.emailAutomationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.emailAutomationFaqQuestion3',
        answer: 'SkillSeoPage.emailAutomationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'marketing-automation',
      'automations',
      'lead-generation',
      'database-management',
      'email-marketing',
    ],
  },
  {
    id: 'email-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'email_marketing',
    path: '/sahkopostimarkkinointi',
    name: 'EmailMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.emailMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.emailMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.emailMarketingHeroPill',
    heroTitle: 'SkillSeoPage.emailMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.emailMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.emailMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.emailMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.emailMarketingFaqQuestion1',
        answer: 'SkillSeoPage.emailMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.emailMarketingFaqQuestion2',
        answer: 'SkillSeoPage.emailMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.emailMarketingFaqQuestion3',
        answer: 'SkillSeoPage.emailMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'email-automation',
      'marketing-automation',
      'inbound-marketing',
      'event-production',
      'scriptwriting',
    ],
  },
  {
    id: 'employer-branding',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'employer_branding',
    path: '/tyonantajamielikuva',
    name: 'EmployerBrandingSkillPage',
    schemaTitle: 'SkillSeoPage.employerBrandingSchemaTitle',
    schemaDescription: 'SkillSeoPage.employerBrandingSchemaDescription',
    heroPill: 'SkillSeoPage.employerBrandingHeroPill',
    heroTitle: 'SkillSeoPage.employerBrandingHeroTitle',
    heroSubtitle: 'SkillSeoPage.employerBrandingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.employerBrandingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.employerBrandingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.employerBrandingFaqQuestion1',
        answer: 'SkillSeoPage.employerBrandingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.employerBrandingFaqQuestion2',
        answer: 'SkillSeoPage.employerBrandingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.employerBrandingFaqQuestion3',
        answer: 'SkillSeoPage.employerBrandingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'internal-communication',
      'communication-strategy',
      'inbound-marketing',
      'brand-strategy',
      'brand-consultation',
    ],
  },
  {
    id: 'event-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'event_marketing',
    path: '/tapahtumamarkkinointi',
    name: 'EventMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.eventMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.eventMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.eventMarketingHeroPill',
    heroTitle: 'SkillSeoPage.eventMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.eventMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.eventMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.eventMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.eventMarketingFaqQuestion1',
        answer: 'SkillSeoPage.eventMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.eventMarketingFaqQuestion2',
        answer: 'SkillSeoPage.eventMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.eventMarketingFaqQuestion3',
        answer: 'SkillSeoPage.eventMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'event-production',
      'product-marketing',
      'short-form-video-production',
      'user-generated-content',
      'instagram-marketing',
    ],
  },
  {
    id: 'event-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'event_photography',
    path: '/tapahtumavalokuvaus',
    name: 'EventPhotographySkillPage',
    schemaTitle: 'SkillSeoPage.eventPhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.eventPhotographySchemaDescription',
    heroPill: 'SkillSeoPage.eventPhotographyHeroPill',
    heroTitle: 'SkillSeoPage.eventPhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.eventPhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.eventPhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.eventPhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.eventPhotographyFaqQuestion1',
        answer: 'SkillSeoPage.eventPhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.eventPhotographyFaqQuestion2',
        answer: 'SkillSeoPage.eventPhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.eventPhotographyFaqQuestion3',
        answer: 'SkillSeoPage.eventPhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'real-estate-photography',
      'studio-photography',
      'portrait-photography',
      'landscape-photography',
      'videography',
    ],
  },
  {
    id: 'event-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'event_production',
    path: '/tapahtumatuotanto',
    name: 'EventProductionSkillPage',
    schemaTitle: 'SkillSeoPage.eventProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.eventProductionSchemaDescription',
    heroPill: 'SkillSeoPage.eventProductionHeroPill',
    heroTitle: 'SkillSeoPage.eventProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.eventProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.eventProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.eventProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.eventProductionFaqQuestion1',
        answer: 'SkillSeoPage.eventProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.eventProductionFaqQuestion2',
        answer: 'SkillSeoPage.eventProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.eventProductionFaqQuestion3',
        answer: 'SkillSeoPage.eventProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'event-marketing',
      'project-management',
      'email-marketing',
      'content-creation',
      'social-media-content',
    ],
  },
  {
    id: 'financial-controlling',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'financial_controlling',
    path: '/financial-controlling',
    name: 'FinancialControllingSkillPage',
    schemaTitle: 'SkillSeoPage.financialControllingSchemaTitle',
    schemaDescription: 'SkillSeoPage.financialControllingSchemaDescription',
    heroPill: 'SkillSeoPage.financialControllingHeroPill',
    heroTitle: 'SkillSeoPage.financialControllingHeroTitle',
    heroSubtitle: 'SkillSeoPage.financialControllingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.financialControllingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.financialControllingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.financialControllingFaqQuestion1',
        answer: 'SkillSeoPage.financialControllingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.financialControllingFaqQuestion2',
        answer: 'SkillSeoPage.financialControllingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.financialControllingFaqQuestion3',
        answer: 'SkillSeoPage.financialControllingFaqAnswer3',
      },
    ],
    relatedSkills: ['crm', 'hr-strategy', 'project-management', 'recruitment', 'employer-branding'],
  },
  {
    id: 'flyer-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'flyer_design',
    path: '/flyerien-suunnittelu',
    name: 'FlyerDesignSkillPage',
    schemaTitle: 'SkillSeoPage.flyerDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.flyerDesignSchemaDescription',
    heroPill: 'SkillSeoPage.flyerDesignHeroPill',
    heroTitle: 'SkillSeoPage.flyerDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.flyerDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.flyerDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.flyerDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.flyerDesignFaqQuestion1',
        answer: 'SkillSeoPage.flyerDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.flyerDesignFaqQuestion2',
        answer: 'SkillSeoPage.flyerDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.flyerDesignFaqQuestion3',
        answer: 'SkillSeoPage.flyerDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'vector-design',
      'poster-design',
      'book-cover-design',
      'business-card-design',
      'infographics',
    ],
  },
  {
    id: 'front-end-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'front_end_development',
    path: '/frontend-kehitys',
    name: 'FrontEndDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.frontEndDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.frontEndDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.frontEndDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.frontEndDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.frontEndDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.frontEndDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.frontEndDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.frontEndDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.frontEndDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.frontEndDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.frontEndDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.frontEndDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.frontEndDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ios-development',
      'back-end-development',
      'cross-platform-development',
      'android-development',
      'mobile-app-development',
    ],
  },
  {
    id: 'ghostwriting',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ghostwriting',
    path: '/haamukirjoittaminen',
    name: 'GhostwritingSkillPage',
    schemaTitle: 'SkillSeoPage.ghostwritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.ghostwritingSchemaDescription',
    heroPill: 'SkillSeoPage.ghostwritingHeroPill',
    heroTitle: 'SkillSeoPage.ghostwritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.ghostwritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.ghostwritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.ghostwritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.ghostwritingFaqQuestion1',
        answer: 'SkillSeoPage.ghostwritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.ghostwritingFaqQuestion2',
        answer: 'SkillSeoPage.ghostwritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.ghostwritingFaqQuestion3',
        answer: 'SkillSeoPage.ghostwritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'content-strategy',
      'copywriting',
      'seo-writing',
      'blog-writing',
      'content-marketing',
    ],
  },
  {
    id: 'graphic-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'graphic_design',
    path: '/graafinen-suunnittelu',
    name: 'GraphicDesignSkillPage',
    schemaTitle: 'SkillSeoPage.graphicDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.graphicDesignSchemaDescription',
    heroPill: 'SkillSeoPage.graphicDesignHeroPill',
    heroTitle: 'SkillSeoPage.graphicDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.graphicDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.graphicDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.graphicDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.graphicDesignFaqQuestion1',
        answer: 'SkillSeoPage.graphicDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.graphicDesignFaqQuestion2',
        answer: 'SkillSeoPage.graphicDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.graphicDesignFaqQuestion3',
        answer: 'SkillSeoPage.graphicDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-layout',
      'packaging-design',
      'vector-design',
      'infographics',
      'print-design',
    ],
  },
  {
    id: 'growth-hacking',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'growth_hacking',
    path: '/kasvuhakkerointi',
    name: 'GrowthHackingSkillPage',
    schemaTitle: 'SkillSeoPage.growthHackingSchemaTitle',
    schemaDescription: 'SkillSeoPage.growthHackingSchemaDescription',
    heroPill: 'SkillSeoPage.growthHackingHeroPill',
    heroTitle: 'SkillSeoPage.growthHackingHeroTitle',
    heroSubtitle: 'SkillSeoPage.growthHackingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.growthHackingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.growthHackingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.growthHackingFaqQuestion1',
        answer: 'SkillSeoPage.growthHackingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.growthHackingFaqQuestion2',
        answer: 'SkillSeoPage.growthHackingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.growthHackingFaqQuestion3',
        answer: 'SkillSeoPage.growthHackingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'lead-generation',
      'conversion-rate-optimization',
      'ab-testing',
      'marketing-automation',
      'inbound-marketing',
    ],
  },
  {
    id: 'gtm-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'gtm_strategy',
    path: '/gtm-strategia',
    name: 'GtmStrategySkillPage',
    schemaTitle: 'SkillSeoPage.gtmStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.gtmStrategySchemaDescription',
    heroPill: 'SkillSeoPage.gtmStrategyHeroPill',
    heroTitle: 'SkillSeoPage.gtmStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.gtmStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.gtmStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.gtmStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.gtmStrategyFaqQuestion1',
        answer: 'SkillSeoPage.gtmStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.gtmStrategyFaqQuestion2',
        answer: 'SkillSeoPage.gtmStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.gtmStrategyFaqQuestion3',
        answer: 'SkillSeoPage.gtmStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-strategy',
      'product-management',
      'product-marketing',
      'lifecycle-marketing',
      'marketing-strategy',
    ],
  },
  {
    id: 'hr-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'hr_strategy',
    path: '/hr-strategia',
    name: 'HrStrategySkillPage',
    schemaTitle: 'SkillSeoPage.hrStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.hrStrategySchemaDescription',
    heroPill: 'SkillSeoPage.hrStrategyHeroPill',
    heroTitle: 'SkillSeoPage.hrStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.hrStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.hrStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.hrStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.hrStrategyFaqQuestion1',
        answer: 'SkillSeoPage.hrStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.hrStrategyFaqQuestion2',
        answer: 'SkillSeoPage.hrStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.hrStrategyFaqQuestion3',
        answer: 'SkillSeoPage.hrStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'recruitment',
      'project-management',
      'b2b-marketing',
      'financial-controlling',
      'employer-branding',
    ],
  },
  {
    id: 'illustration',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'illustration',
    path: '/kuvitus',
    name: 'IllustrationSkillPage',
    schemaTitle: 'SkillSeoPage.illustrationSchemaTitle',
    schemaDescription: 'SkillSeoPage.illustrationSchemaDescription',
    heroPill: 'SkillSeoPage.illustrationHeroPill',
    heroTitle: 'SkillSeoPage.illustrationHeroTitle',
    heroSubtitle: 'SkillSeoPage.illustrationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.illustrationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.illustrationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.illustrationFaqQuestion1',
        answer: 'SkillSeoPage.illustrationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.illustrationFaqQuestion2',
        answer: 'SkillSeoPage.illustrationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.illustrationFaqQuestion3',
        answer: 'SkillSeoPage.illustrationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'character-design',
      'drawing',
      'concept-art',
      'book-cover-design',
      'vector-design',
    ],
  },
  {
    id: 'image-retouching',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'image_retouching',
    path: '/kuvien-retusointi',
    name: 'ImageRetouchingSkillPage',
    schemaTitle: 'SkillSeoPage.imageRetouchingSchemaTitle',
    schemaDescription: 'SkillSeoPage.imageRetouchingSchemaDescription',
    heroPill: 'SkillSeoPage.imageRetouchingHeroPill',
    heroTitle: 'SkillSeoPage.imageRetouchingHeroTitle',
    heroSubtitle: 'SkillSeoPage.imageRetouchingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.imageRetouchingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.imageRetouchingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.imageRetouchingFaqQuestion1',
        answer: 'SkillSeoPage.imageRetouchingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.imageRetouchingFaqQuestion2',
        answer: 'SkillSeoPage.imageRetouchingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.imageRetouchingFaqQuestion3',
        answer: 'SkillSeoPage.imageRetouchingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'studio-photography',
      'vector-design',
      'book-layout',
      'video-effects',
      'poster-design',
    ],
  },
  {
    id: 'inbound-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'inbound_marketing',
    path: '/inbound-markkinointi',
    name: 'InboundMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.inboundMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.inboundMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.inboundMarketingHeroPill',
    heroTitle: 'SkillSeoPage.inboundMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.inboundMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.inboundMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.inboundMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.inboundMarketingFaqQuestion1',
        answer: 'SkillSeoPage.inboundMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.inboundMarketingFaqQuestion2',
        answer: 'SkillSeoPage.inboundMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.inboundMarketingFaqQuestion3',
        answer: 'SkillSeoPage.inboundMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'marketing-automation',
      'lead-generation',
      'growth-hacking',
      'seo-strategy',
      'crm',
    ],
  },
  {
    id: 'influencer-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'influencer_marketing',
    path: '/vaikuttajamarkkinointi',
    name: 'InfluencerMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.influencerMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.influencerMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.influencerMarketingHeroPill',
    heroTitle: 'SkillSeoPage.influencerMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.influencerMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.influencerMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.influencerMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.influencerMarketingFaqQuestion1',
        answer: 'SkillSeoPage.influencerMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.influencerMarketingFaqQuestion2',
        answer: 'SkillSeoPage.influencerMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.influencerMarketingFaqQuestion3',
        answer: 'SkillSeoPage.influencerMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'public-relations',
      'media-relations',
      'content-strategy',
      'brand-partnership',
      'social-media-strategy',
    ],
  },
  {
    id: 'infographics',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'infographics',
    path: '/infografiikat',
    name: 'InfographicsSkillPage',
    schemaTitle: 'SkillSeoPage.infographicsSchemaTitle',
    schemaDescription: 'SkillSeoPage.infographicsSchemaDescription',
    heroPill: 'SkillSeoPage.infographicsHeroPill',
    heroTitle: 'SkillSeoPage.infographicsHeroTitle',
    heroSubtitle: 'SkillSeoPage.infographicsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.infographicsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.infographicsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.infographicsFaqQuestion1',
        answer: 'SkillSeoPage.infographicsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.infographicsFaqQuestion2',
        answer: 'SkillSeoPage.infographicsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.infographicsFaqQuestion3',
        answer: 'SkillSeoPage.infographicsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-layout',
      'motion-graphics',
      'packaging-design',
      'vector-design',
      '2d-animation',
    ],
  },
  {
    id: 'instagram-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'instagram_marketing',
    path: '/instagram-markkinointi',
    name: 'InstagramMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.instagramMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.instagramMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.instagramMarketingHeroPill',
    heroTitle: 'SkillSeoPage.instagramMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.instagramMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.instagramMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.instagramMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.instagramMarketingFaqQuestion1',
        answer: 'SkillSeoPage.instagramMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.instagramMarketingFaqQuestion2',
        answer: 'SkillSeoPage.instagramMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.instagramMarketingFaqQuestion3',
        answer: 'SkillSeoPage.instagramMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'public-relations',
      'event-marketing',
      'search-engine-marketing',
      'content-strategy',
      'brand-partnership',
    ],
  },
  {
    id: 'internal-communication',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'internal_communication',
    path: '/sisainen-viestinta',
    name: 'InternalCommunicationSkillPage',
    schemaTitle: 'SkillSeoPage.internalCommunicationSchemaTitle',
    schemaDescription: 'SkillSeoPage.internalCommunicationSchemaDescription',
    heroPill: 'SkillSeoPage.internalCommunicationHeroPill',
    heroTitle: 'SkillSeoPage.internalCommunicationHeroTitle',
    heroSubtitle: 'SkillSeoPage.internalCommunicationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.internalCommunicationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.internalCommunicationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.internalCommunicationFaqQuestion1',
        answer: 'SkillSeoPage.internalCommunicationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.internalCommunicationFaqQuestion2',
        answer: 'SkillSeoPage.internalCommunicationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.internalCommunicationFaqQuestion3',
        answer: 'SkillSeoPage.internalCommunicationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'crisis-management',
      'media-relations',
      'communication-strategy',
      'employer-branding',
      'public-relations',
    ],
  },
  {
    id: 'investor-relations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'investor_relations',
    path: '/sijoittajasuhteet',
    name: 'InvestorRelationsSkillPage',
    schemaTitle: 'SkillSeoPage.investorRelationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.investorRelationsSchemaDescription',
    heroPill: 'SkillSeoPage.investorRelationsHeroPill',
    heroTitle: 'SkillSeoPage.investorRelationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.investorRelationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.investorRelationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.investorRelationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.investorRelationsFaqQuestion1',
        answer: 'SkillSeoPage.investorRelationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.investorRelationsFaqQuestion2',
        answer: 'SkillSeoPage.investorRelationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.investorRelationsFaqQuestion3',
        answer: 'SkillSeoPage.investorRelationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'media-relations',
      'public-relations',
      'crisis-management',
      'internal-communication',
      'communication-strategy',
    ],
  },
  {
    id: 'ios-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ios_development',
    path: '/ios-kehitys',
    name: 'IosDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.iosDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.iosDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.iosDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.iosDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.iosDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.iosDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.iosDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.iosDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.iosDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.iosDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.iosDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.iosDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.iosDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'android-development',
      'mobile-app-development',
      'api-development',
      'front-end-development',
      'web-development',
    ],
  },
  {
    id: 'keyword-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'keyword_research',
    path: '/avainsanatutkimus',
    name: 'KeywordResearchSkillPage',
    schemaTitle: 'SkillSeoPage.keywordResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.keywordResearchSchemaDescription',
    heroPill: 'SkillSeoPage.keywordResearchHeroPill',
    heroTitle: 'SkillSeoPage.keywordResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.keywordResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.keywordResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.keywordResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.keywordResearchFaqQuestion1',
        answer: 'SkillSeoPage.keywordResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.keywordResearchFaqQuestion2',
        answer: 'SkillSeoPage.keywordResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.keywordResearchFaqQuestion3',
        answer: 'SkillSeoPage.keywordResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-audit',
      'seo-strategy',
      'technical-seo',
      'search-engine-marketing',
      'seo-writing',
    ],
  },
  {
    id: 'landing-page-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'landing_page_design',
    path: '/laskeutumissivun-suunnittelu',
    name: 'LandingPageDesignSkillPage',
    schemaTitle: 'SkillSeoPage.landingPageDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.landingPageDesignSchemaDescription',
    heroPill: 'SkillSeoPage.landingPageDesignHeroPill',
    heroTitle: 'SkillSeoPage.landingPageDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.landingPageDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.landingPageDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.landingPageDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.landingPageDesignFaqQuestion1',
        answer: 'SkillSeoPage.landingPageDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.landingPageDesignFaqQuestion2',
        answer: 'SkillSeoPage.landingPageDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.landingPageDesignFaqQuestion3',
        answer: 'SkillSeoPage.landingPageDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ui-design',
      'mobile-app-design',
      'conversion-rate-optimization',
      'ux-writing',
      'ux-design',
    ],
  },
  {
    id: 'landscape-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'landscape_photography',
    path: '/maisemavalokuvaus',
    name: 'LandscapePhotographySkillPage',
    schemaTitle: 'SkillSeoPage.landscapePhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.landscapePhotographySchemaDescription',
    heroPill: 'SkillSeoPage.landscapePhotographyHeroPill',
    heroTitle: 'SkillSeoPage.landscapePhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.landscapePhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.landscapePhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.landscapePhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.landscapePhotographyFaqQuestion1',
        answer: 'SkillSeoPage.landscapePhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.landscapePhotographyFaqQuestion2',
        answer: 'SkillSeoPage.landscapePhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.landscapePhotographyFaqQuestion3',
        answer: 'SkillSeoPage.landscapePhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'real-estate-photography',
      'portrait-photography',
      'event-photography',
      'drone-videography',
      'product-photography',
    ],
  },
  {
    id: 'lead-generation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'lead_generation',
    path: '/liidien-generointi',
    name: 'LeadGenerationSkillPage',
    schemaTitle: 'SkillSeoPage.leadGenerationSchemaTitle',
    schemaDescription: 'SkillSeoPage.leadGenerationSchemaDescription',
    heroPill: 'SkillSeoPage.leadGenerationHeroPill',
    heroTitle: 'SkillSeoPage.leadGenerationHeroTitle',
    heroSubtitle: 'SkillSeoPage.leadGenerationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.leadGenerationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.leadGenerationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.leadGenerationFaqQuestion1',
        answer: 'SkillSeoPage.leadGenerationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.leadGenerationFaqQuestion2',
        answer: 'SkillSeoPage.leadGenerationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.leadGenerationFaqQuestion3',
        answer: 'SkillSeoPage.leadGenerationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'growth-hacking',
      'marketing-automation',
      'inbound-marketing',
      'ab-testing',
      'email-automation',
    ],
  },
  {
    id: 'lifecycle-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'lifecycle_marketing',
    path: '/elinkaarimarkkinointi',
    name: 'LifecycleMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.lifecycleMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.lifecycleMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.lifecycleMarketingHeroPill',
    heroTitle: 'SkillSeoPage.lifecycleMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.lifecycleMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.lifecycleMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.lifecycleMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.lifecycleMarketingFaqQuestion1',
        answer: 'SkillSeoPage.lifecycleMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.lifecycleMarketingFaqQuestion2',
        answer: 'SkillSeoPage.lifecycleMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.lifecycleMarketingFaqQuestion3',
        answer: 'SkillSeoPage.lifecycleMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'b2c-marketing',
      'marketing-strategy',
      'digital-marketing',
      'gtm-strategy',
      'product-management',
    ],
  },
  {
    id: 'link-building',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'link_building',
    path: '/linkkien-rakentaminen',
    name: 'LinkBuildingSkillPage',
    schemaTitle: 'SkillSeoPage.linkBuildingSchemaTitle',
    schemaDescription: 'SkillSeoPage.linkBuildingSchemaDescription',
    heroPill: 'SkillSeoPage.linkBuildingHeroPill',
    heroTitle: 'SkillSeoPage.linkBuildingHeroTitle',
    heroSubtitle: 'SkillSeoPage.linkBuildingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.linkBuildingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.linkBuildingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.linkBuildingFaqQuestion1',
        answer: 'SkillSeoPage.linkBuildingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.linkBuildingFaqQuestion2',
        answer: 'SkillSeoPage.linkBuildingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.linkBuildingFaqQuestion3',
        answer: 'SkillSeoPage.linkBuildingFaqAnswer3',
      },
    ],
    relatedSkills: ['seo', 'seo-audit', 'technical-seo', 'keyword-research', 'seo-writing'],
  },
  {
    id: 'logo-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'logo_design',
    path: '/logon-suunnittelu',
    name: 'LogoDesignSkillPage',
    schemaTitle: 'SkillSeoPage.logoDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.logoDesignSchemaDescription',
    heroPill: 'SkillSeoPage.logoDesignHeroPill',
    heroTitle: 'SkillSeoPage.logoDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.logoDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.logoDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.logoDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.logoDesignFaqQuestion1',
        answer: 'SkillSeoPage.logoDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.logoDesignFaqQuestion2',
        answer: 'SkillSeoPage.logoDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.logoDesignFaqQuestion3',
        answer: 'SkillSeoPage.logoDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'packaging-design',
      'book-layout',
      'vector-design',
      'print-design',
      'infographics',
    ],
  },
  {
    id: 'machine-learning',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'machine_learning',
    path: '/koneoppiminen',
    name: 'MachineLearningSkillPage',
    schemaTitle: 'SkillSeoPage.machineLearningSchemaTitle',
    schemaDescription: 'SkillSeoPage.machineLearningSchemaDescription',
    heroPill: 'SkillSeoPage.machineLearningHeroPill',
    heroTitle: 'SkillSeoPage.machineLearningHeroTitle',
    heroSubtitle: 'SkillSeoPage.machineLearningHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.machineLearningFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.machineLearningFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.machineLearningFaqQuestion1',
        answer: 'SkillSeoPage.machineLearningFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.machineLearningFaqQuestion2',
        answer: 'SkillSeoPage.machineLearningFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.machineLearningFaqQuestion3',
        answer: 'SkillSeoPage.machineLearningFaqAnswer3',
      },
    ],
    relatedSkills: [
      'neural-networks',
      'computer-vision',
      'deep-learning',
      'data-science',
      'ai-development',
    ],
  },
  {
    id: 'market-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'market_research',
    path: '/markkinatutkimus',
    name: 'MarketResearchSkillPage',
    schemaTitle: 'SkillSeoPage.marketResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.marketResearchSchemaDescription',
    heroPill: 'SkillSeoPage.marketResearchHeroPill',
    heroTitle: 'SkillSeoPage.marketResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.marketResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.marketResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.marketResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.marketResearchFaqQuestion1',
        answer: 'SkillSeoPage.marketResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.marketResearchFaqQuestion2',
        answer: 'SkillSeoPage.marketResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.marketResearchFaqQuestion3',
        answer: 'SkillSeoPage.marketResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'b2b-marketing',
      'digital-marketing',
      'market-segmentation',
      'consumer-research',
      'target-group-research',
    ],
  },
  {
    id: 'market-segmentation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'market_segmentation',
    path: '/segmentointi',
    name: 'MarketSegmentationSkillPage',
    schemaTitle: 'SkillSeoPage.marketSegmentationSchemaTitle',
    schemaDescription: 'SkillSeoPage.marketSegmentationSchemaDescription',
    heroPill: 'SkillSeoPage.marketSegmentationHeroPill',
    heroTitle: 'SkillSeoPage.marketSegmentationHeroTitle',
    heroSubtitle: 'SkillSeoPage.marketSegmentationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.marketSegmentationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.marketSegmentationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.marketSegmentationFaqQuestion1',
        answer: 'SkillSeoPage.marketSegmentationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.marketSegmentationFaqQuestion2',
        answer: 'SkillSeoPage.marketSegmentationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.marketSegmentationFaqQuestion3',
        answer: 'SkillSeoPage.marketSegmentationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'market-research',
      'consumer-research',
      'target-group-research',
      'brand-research',
      'user-research',
    ],
  },
  {
    id: 'marketing-automation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'marketing_automation',
    path: '/markkinointiautomaatio',
    name: 'MarketingAutomationSkillPage',
    schemaTitle: 'SkillSeoPage.marketingAutomationSchemaTitle',
    schemaDescription: 'SkillSeoPage.marketingAutomationSchemaDescription',
    heroPill: 'SkillSeoPage.marketingAutomationHeroPill',
    heroTitle: 'SkillSeoPage.marketingAutomationHeroTitle',
    heroSubtitle: 'SkillSeoPage.marketingAutomationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.marketingAutomationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.marketingAutomationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.marketingAutomationFaqQuestion1',
        answer: 'SkillSeoPage.marketingAutomationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.marketingAutomationFaqQuestion2',
        answer: 'SkillSeoPage.marketingAutomationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.marketingAutomationFaqQuestion3',
        answer: 'SkillSeoPage.marketingAutomationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'email-automation',
      'inbound-marketing',
      'lead-generation',
      'growth-hacking',
      'crm',
    ],
  },
  {
    id: 'marketing-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'marketing_strategy',
    path: '/markkinointistrategia',
    name: 'MarketingStrategySkillPage',
    schemaTitle: 'SkillSeoPage.marketingStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.marketingStrategySchemaDescription',
    heroPill: 'SkillSeoPage.marketingStrategyHeroPill',
    heroTitle: 'SkillSeoPage.marketingStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.marketingStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.marketingStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.marketingStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.marketingStrategyFaqQuestion1',
        answer: 'SkillSeoPage.marketingStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.marketingStrategyFaqQuestion2',
        answer: 'SkillSeoPage.marketingStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.marketingStrategyFaqQuestion3',
        answer: 'SkillSeoPage.marketingStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'lifecycle-marketing',
      'media-strategy',
      'marketing-automation',
      'inbound-marketing',
      'search-engine-marketing',
    ],
  },
  {
    id: 'media-relations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'media_relations',
    path: '/mediasuhteet',
    name: 'MediaRelationsSkillPage',
    schemaTitle: 'SkillSeoPage.mediaRelationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.mediaRelationsSchemaDescription',
    heroPill: 'SkillSeoPage.mediaRelationsHeroPill',
    heroTitle: 'SkillSeoPage.mediaRelationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.mediaRelationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.mediaRelationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.mediaRelationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.mediaRelationsFaqQuestion1',
        answer: 'SkillSeoPage.mediaRelationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.mediaRelationsFaqQuestion2',
        answer: 'SkillSeoPage.mediaRelationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.mediaRelationsFaqQuestion3',
        answer: 'SkillSeoPage.mediaRelationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'crisis-management',
      'public-relations',
      'internal-communication',
      'communication-strategy',
      'influencer-marketing',
    ],
  },
  {
    id: 'media-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'media_strategy',
    path: '/mediastrategia',
    name: 'MediaStrategySkillPage',
    schemaTitle: 'SkillSeoPage.mediaStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.mediaStrategySchemaDescription',
    heroPill: 'SkillSeoPage.mediaStrategyHeroPill',
    heroTitle: 'SkillSeoPage.mediaStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.mediaStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.mediaStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.mediaStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.mediaStrategyFaqQuestion1',
        answer: 'SkillSeoPage.mediaStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.mediaStrategyFaqQuestion2',
        answer: 'SkillSeoPage.mediaStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.mediaStrategyFaqQuestion3',
        answer: 'SkillSeoPage.mediaStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'brand-strategy',
      'social-media-strategy',
      'marketing-strategy',
      'digital-marketing',
      'content-creation',
    ],
  },
  {
    id: 'mobile-app-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'mobile_app_design',
    path: '/mobiilisovelluksen-suunnittelu',
    name: 'MobileAppDesignSkillPage',
    schemaTitle: 'SkillSeoPage.mobileAppDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.mobileAppDesignSchemaDescription',
    heroPill: 'SkillSeoPage.mobileAppDesignHeroPill',
    heroTitle: 'SkillSeoPage.mobileAppDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.mobileAppDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.mobileAppDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.mobileAppDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.mobileAppDesignFaqQuestion1',
        answer: 'SkillSeoPage.mobileAppDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.mobileAppDesignFaqQuestion2',
        answer: 'SkillSeoPage.mobileAppDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.mobileAppDesignFaqQuestion3',
        answer: 'SkillSeoPage.mobileAppDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'user-research',
      'ui-design',
      'user-interface-testing',
      'ux-design',
      'ux-writing',
    ],
  },
  {
    id: 'mobile-app-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'mobile_app_development',
    path: '/mobiilisovellusten-kehittaminen',
    name: 'MobileAppDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.mobileAppDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.mobileAppDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.mobileAppDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.mobileAppDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.mobileAppDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.mobileAppDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.mobileAppDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.mobileAppDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.mobileAppDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.mobileAppDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.mobileAppDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.mobileAppDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.mobileAppDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ios-development',
      'android-development',
      'application-architecture',
      'back-end-development',
      'api-development',
    ],
  },
  {
    id: 'motion-graphics',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'motion_graphics',
    path: '/liikegrafiikka',
    name: 'MotionGraphicsSkillPage',
    schemaTitle: 'SkillSeoPage.motionGraphicsSchemaTitle',
    schemaDescription: 'SkillSeoPage.motionGraphicsSchemaDescription',
    heroPill: 'SkillSeoPage.motionGraphicsHeroPill',
    heroTitle: 'SkillSeoPage.motionGraphicsHeroTitle',
    heroSubtitle: 'SkillSeoPage.motionGraphicsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.motionGraphicsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.motionGraphicsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.motionGraphicsFaqQuestion1',
        answer: 'SkillSeoPage.motionGraphicsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.motionGraphicsFaqQuestion2',
        answer: 'SkillSeoPage.motionGraphicsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.motionGraphicsFaqQuestion3',
        answer: 'SkillSeoPage.motionGraphicsFaqAnswer3',
      },
    ],
    relatedSkills: [
      '2d-animation',
      'book-layout',
      'video-effects',
      'book-cover-design',
      'infographics',
    ],
  },
  {
    id: 'natural-language-processing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'natural_language_processing',
    path: '/luonnollisen-kielen-kasittely',
    name: 'NaturalLanguageProcessingSkillPage',
    schemaTitle: 'SkillSeoPage.naturalLanguageProcessingSchemaTitle',
    schemaDescription: 'SkillSeoPage.naturalLanguageProcessingSchemaDescription',
    heroPill: 'SkillSeoPage.naturalLanguageProcessingHeroPill',
    heroTitle: 'SkillSeoPage.naturalLanguageProcessingHeroTitle',
    heroSubtitle: 'SkillSeoPage.naturalLanguageProcessingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.naturalLanguageProcessingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.naturalLanguageProcessingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.naturalLanguageProcessingFaqQuestion1',
        answer: 'SkillSeoPage.naturalLanguageProcessingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.naturalLanguageProcessingFaqQuestion2',
        answer: 'SkillSeoPage.naturalLanguageProcessingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.naturalLanguageProcessingFaqQuestion3',
        answer: 'SkillSeoPage.naturalLanguageProcessingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'proofreading',
      'translation',
      'ai-text-production',
      'advertising-copywriting',
      'article-writing',
    ],
  },
  {
    id: 'neural-networks',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'neural_networks',
    path: '/neuroverkot',
    name: 'NeuralNetworksSkillPage',
    schemaTitle: 'SkillSeoPage.neuralNetworksSchemaTitle',
    schemaDescription: 'SkillSeoPage.neuralNetworksSchemaDescription',
    heroPill: 'SkillSeoPage.neuralNetworksHeroPill',
    heroTitle: 'SkillSeoPage.neuralNetworksHeroTitle',
    heroSubtitle: 'SkillSeoPage.neuralNetworksHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.neuralNetworksFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.neuralNetworksFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.neuralNetworksFaqQuestion1',
        answer: 'SkillSeoPage.neuralNetworksFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.neuralNetworksFaqQuestion2',
        answer: 'SkillSeoPage.neuralNetworksFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.neuralNetworksFaqQuestion3',
        answer: 'SkillSeoPage.neuralNetworksFaqAnswer3',
      },
    ],
    relatedSkills: [
      'machine-learning',
      'deep-learning',
      'computer-vision',
      'big-data',
      'data-science',
    ],
  },
  {
    id: 'packaging-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'packaging_design',
    path: '/pakkaussuunnittelu',
    name: 'PackagingDesignSkillPage',
    schemaTitle: 'SkillSeoPage.packagingDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.packagingDesignSchemaDescription',
    heroPill: 'SkillSeoPage.packagingDesignHeroPill',
    heroTitle: 'SkillSeoPage.packagingDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.packagingDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.packagingDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.packagingDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.packagingDesignFaqQuestion1',
        answer: 'SkillSeoPage.packagingDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.packagingDesignFaqQuestion2',
        answer: 'SkillSeoPage.packagingDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.packagingDesignFaqQuestion3',
        answer: 'SkillSeoPage.packagingDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-layout',
      'book-cover-design',
      'infographics',
      'vector-design',
      'motion-graphics',
    ],
  },
  {
    id: 'photo-editing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'photo_editing',
    path: '/kuvien-editointi',
    name: 'PhotoEditingSkillPage',
    schemaTitle: 'SkillSeoPage.photoEditingSchemaTitle',
    schemaDescription: 'SkillSeoPage.photoEditingSchemaDescription',
    heroPill: 'SkillSeoPage.photoEditingHeroPill',
    heroTitle: 'SkillSeoPage.photoEditingHeroTitle',
    heroSubtitle: 'SkillSeoPage.photoEditingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.photoEditingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.photoEditingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.photoEditingFaqQuestion1',
        answer: 'SkillSeoPage.photoEditingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.photoEditingFaqQuestion2',
        answer: 'SkillSeoPage.photoEditingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.photoEditingFaqQuestion3',
        answer: 'SkillSeoPage.photoEditingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'studio-photography',
      'image-retouching',
      'real-estate-photography',
      'portrait-photography',
      'product-photography',
    ],
  },
  {
    id: 'pipeline-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'pipeline_management',
    path: '/myyntiputken-hallinta',
    name: 'PipelineManagementSkillPage',
    schemaTitle: 'SkillSeoPage.pipelineManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.pipelineManagementSchemaDescription',
    heroPill: 'SkillSeoPage.pipelineManagementHeroPill',
    heroTitle: 'SkillSeoPage.pipelineManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.pipelineManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.pipelineManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.pipelineManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.pipelineManagementFaqQuestion1',
        answer: 'SkillSeoPage.pipelineManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.pipelineManagementFaqQuestion2',
        answer: 'SkillSeoPage.pipelineManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.pipelineManagementFaqQuestion3',
        answer: 'SkillSeoPage.pipelineManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-operations',
      'sales-strategy',
      'sales-process-development',
      'revenue-operations',
      'revenue-forecasting',
    ],
  },
  {
    id: 'podcast-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'podcast_production',
    path: '/podcast-tuotanto',
    name: 'PodcastProductionSkillPage',
    schemaTitle: 'SkillSeoPage.podcastProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.podcastProductionSchemaDescription',
    heroPill: 'SkillSeoPage.podcastProductionHeroPill',
    heroTitle: 'SkillSeoPage.podcastProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.podcastProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.podcastProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.podcastProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.podcastProductionFaqQuestion1',
        answer: 'SkillSeoPage.podcastProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.podcastProductionFaqQuestion2',
        answer: 'SkillSeoPage.podcastProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.podcastProductionFaqQuestion3',
        answer: 'SkillSeoPage.podcastProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'voice-over',
      'audio-editing',
      'short-form-video-production',
      'video-editing',
      'video-production',
    ],
  },
  {
    id: 'portrait-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'portrait_photography',
    path: '/muotokuvaus',
    name: 'PortraitPhotographySkillPage',
    schemaTitle: 'SkillSeoPage.portraitPhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.portraitPhotographySchemaDescription',
    heroPill: 'SkillSeoPage.portraitPhotographyHeroPill',
    heroTitle: 'SkillSeoPage.portraitPhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.portraitPhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.portraitPhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.portraitPhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.portraitPhotographyFaqQuestion1',
        answer: 'SkillSeoPage.portraitPhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.portraitPhotographyFaqQuestion2',
        answer: 'SkillSeoPage.portraitPhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.portraitPhotographyFaqQuestion3',
        answer: 'SkillSeoPage.portraitPhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'studio-photography',
      'event-photography',
      'landscape-photography',
      'real-estate-photography',
      'commercial-photography',
    ],
  },
  {
    id: 'poster-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'poster_design',
    path: '/julisteen-suunnittelu',
    name: 'PosterDesignSkillPage',
    schemaTitle: 'SkillSeoPage.posterDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.posterDesignSchemaDescription',
    heroPill: 'SkillSeoPage.posterDesignHeroPill',
    heroTitle: 'SkillSeoPage.posterDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.posterDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.posterDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.posterDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.posterDesignFaqQuestion1',
        answer: 'SkillSeoPage.posterDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.posterDesignFaqQuestion2',
        answer: 'SkillSeoPage.posterDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.posterDesignFaqQuestion3',
        answer: 'SkillSeoPage.posterDesignFaqAnswer3',
      },
    ],
    relatedSkills: ['book-cover-design', 'book-layout', 'vector-design', 'drawing', 'infographics'],
  },
  {
    id: 'print-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'print_design',
    path: '/printtisuunnittelu',
    name: 'PrintDesignSkillPage',
    schemaTitle: 'SkillSeoPage.printDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.printDesignSchemaDescription',
    heroPill: 'SkillSeoPage.printDesignHeroPill',
    heroTitle: 'SkillSeoPage.printDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.printDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.printDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.printDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.printDesignFaqQuestion1',
        answer: 'SkillSeoPage.printDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.printDesignFaqQuestion2',
        answer: 'SkillSeoPage.printDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.printDesignFaqQuestion3',
        answer: 'SkillSeoPage.printDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'book-layout',
      'vector-design',
      'book-cover-design',
      'packaging-design',
      'infographics',
    ],
  },
  {
    id: 'product-description-writing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'product_description_writing',
    path: '/tuotekuvausten-kirjoittaminen',
    name: 'ProductDescriptionWritingSkillPage',
    schemaTitle: 'SkillSeoPage.productDescriptionWritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.productDescriptionWritingSchemaDescription',
    heroPill: 'SkillSeoPage.productDescriptionWritingHeroPill',
    heroTitle: 'SkillSeoPage.productDescriptionWritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.productDescriptionWritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.productDescriptionWritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.productDescriptionWritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.productDescriptionWritingFaqQuestion1',
        answer: 'SkillSeoPage.productDescriptionWritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.productDescriptionWritingFaqQuestion2',
        answer: 'SkillSeoPage.productDescriptionWritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.productDescriptionWritingFaqQuestion3',
        answer: 'SkillSeoPage.productDescriptionWritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'scriptwriting',
      'media-relations',
      'proofreading',
      'transcription',
      'advertising-copywriting',
    ],
  },
  {
    id: 'product-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'product_management',
    path: '/tuotehallinta',
    name: 'ProductManagementSkillPage',
    schemaTitle: 'SkillSeoPage.productManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.productManagementSchemaDescription',
    heroPill: 'SkillSeoPage.productManagementHeroPill',
    heroTitle: 'SkillSeoPage.productManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.productManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.productManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.productManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.productManagementFaqQuestion1',
        answer: 'SkillSeoPage.productManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.productManagementFaqQuestion2',
        answer: 'SkillSeoPage.productManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.productManagementFaqQuestion3',
        answer: 'SkillSeoPage.productManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'gtm-strategy',
      'product-marketing',
      'lifecycle-marketing',
      'marketing-strategy',
    ],
  },
  {
    id: 'product-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'product_marketing',
    path: '/tuotemarkkinointi',
    name: 'ProductMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.productMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.productMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.productMarketingHeroPill',
    heroTitle: 'SkillSeoPage.productMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.productMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.productMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.productMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.productMarketingFaqQuestion1',
        answer: 'SkillSeoPage.productMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.productMarketingFaqQuestion2',
        answer: 'SkillSeoPage.productMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.productMarketingFaqQuestion3',
        answer: 'SkillSeoPage.productMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'event-marketing',
      'public-relations',
      'marketing-automation',
      'lead-generation',
      'search-engine-marketing',
    ],
  },
  {
    id: 'product-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'product_photography',
    path: '/tuotevalokuvaus',
    name: 'ProductPhotographySkillPage',
    schemaTitle: 'SkillSeoPage.productPhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.productPhotographySchemaDescription',
    heroPill: 'SkillSeoPage.productPhotographyHeroPill',
    heroTitle: 'SkillSeoPage.productPhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.productPhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.productPhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.productPhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.productPhotographyFaqQuestion1',
        answer: 'SkillSeoPage.productPhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.productPhotographyFaqQuestion2',
        answer: 'SkillSeoPage.productPhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.productPhotographyFaqQuestion3',
        answer: 'SkillSeoPage.productPhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'studio-photography',
      'real-estate-photography',
      'portrait-photography',
      'landscape-photography',
      'event-photography',
    ],
  },
  {
    id: 'project-management',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'project_management',
    path: '/projektinhallinta',
    name: 'ProjectManagementSkillPage',
    schemaTitle: 'SkillSeoPage.projectManagementSchemaTitle',
    schemaDescription: 'SkillSeoPage.projectManagementSchemaDescription',
    heroPill: 'SkillSeoPage.projectManagementHeroPill',
    heroTitle: 'SkillSeoPage.projectManagementHeroTitle',
    heroSubtitle: 'SkillSeoPage.projectManagementHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.projectManagementFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.projectManagementFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.projectManagementFaqQuestion1',
        answer: 'SkillSeoPage.projectManagementFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.projectManagementFaqQuestion2',
        answer: 'SkillSeoPage.projectManagementFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.projectManagementFaqQuestion3',
        answer: 'SkillSeoPage.projectManagementFaqAnswer3',
      },
    ],
    relatedSkills: [
      'service-development',
      'event-production',
      'hr-strategy',
      'customer-oriented-development',
      'recruitment',
    ],
  },
  {
    id: 'proofreading',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'proofreading',
    path: '/oikoluku',
    name: 'ProofreadingSkillPage',
    schemaTitle: 'SkillSeoPage.proofreadingSchemaTitle',
    schemaDescription: 'SkillSeoPage.proofreadingSchemaDescription',
    heroPill: 'SkillSeoPage.proofreadingHeroPill',
    heroTitle: 'SkillSeoPage.proofreadingHeroTitle',
    heroSubtitle: 'SkillSeoPage.proofreadingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.proofreadingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.proofreadingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.proofreadingFaqQuestion1',
        answer: 'SkillSeoPage.proofreadingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.proofreadingFaqQuestion2',
        answer: 'SkillSeoPage.proofreadingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.proofreadingFaqQuestion3',
        answer: 'SkillSeoPage.proofreadingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'transcription',
      'natural-language-processing',
      'subtitles',
      'translation',
      'media-relations',
    ],
  },
  {
    id: 'public-relations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'public_relations',
    path: '/pr',
    name: 'PublicRelationsSkillPage',
    schemaTitle: 'SkillSeoPage.publicRelationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.publicRelationsSchemaDescription',
    heroPill: 'SkillSeoPage.publicRelationsHeroPill',
    heroTitle: 'SkillSeoPage.publicRelationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.publicRelationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.publicRelationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.publicRelationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.publicRelationsFaqQuestion1',
        answer: 'SkillSeoPage.publicRelationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.publicRelationsFaqQuestion2',
        answer: 'SkillSeoPage.publicRelationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.publicRelationsFaqQuestion3',
        answer: 'SkillSeoPage.publicRelationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'media-relations',
      'content-strategy',
      'influencer-marketing',
      'communication-strategy',
      'brand-partnership',
    ],
  },
  {
    id: 'real-estate-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'real_estate_photography',
    path: '/kiinteistovalokuvaus',
    name: 'RealEstatePhotographySkillPage',
    schemaTitle: 'SkillSeoPage.realEstatePhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.realEstatePhotographySchemaDescription',
    heroPill: 'SkillSeoPage.realEstatePhotographyHeroPill',
    heroTitle: 'SkillSeoPage.realEstatePhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.realEstatePhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.realEstatePhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.realEstatePhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.realEstatePhotographyFaqQuestion1',
        answer: 'SkillSeoPage.realEstatePhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.realEstatePhotographyFaqQuestion2',
        answer: 'SkillSeoPage.realEstatePhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.realEstatePhotographyFaqQuestion3',
        answer: 'SkillSeoPage.realEstatePhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'drone-videography',
      'landscape-photography',
      'event-photography',
      'portrait-photography',
      'studio-photography',
    ],
  },
  {
    id: 'recruitment',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'recruitment',
    path: '/rekrytointi',
    name: 'RecruitmentSkillPage',
    schemaTitle: 'SkillSeoPage.recruitmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.recruitmentSchemaDescription',
    heroPill: 'SkillSeoPage.recruitmentHeroPill',
    heroTitle: 'SkillSeoPage.recruitmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.recruitmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.recruitmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.recruitmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.recruitmentFaqQuestion1',
        answer: 'SkillSeoPage.recruitmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.recruitmentFaqQuestion2',
        answer: 'SkillSeoPage.recruitmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.recruitmentFaqQuestion3',
        answer: 'SkillSeoPage.recruitmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'hr-strategy',
      'data-entry',
      'b2b-sales',
      'project-management',
      'virtual-assistance',
    ],
  },
  {
    id: 'revenue-forecasting',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'revenue_forecasting',
    path: '/liikevaihtoennusteet',
    name: 'RevenueForecastingSkillPage',
    schemaTitle: 'SkillSeoPage.revenueForecastingSchemaTitle',
    schemaDescription: 'SkillSeoPage.revenueForecastingSchemaDescription',
    heroPill: 'SkillSeoPage.revenueForecastingHeroPill',
    heroTitle: 'SkillSeoPage.revenueForecastingHeroTitle',
    heroSubtitle: 'SkillSeoPage.revenueForecastingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.revenueForecastingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.revenueForecastingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.revenueForecastingFaqQuestion1',
        answer: 'SkillSeoPage.revenueForecastingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.revenueForecastingFaqQuestion2',
        answer: 'SkillSeoPage.revenueForecastingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.revenueForecastingFaqQuestion3',
        answer: 'SkillSeoPage.revenueForecastingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-operations',
      'sales-strategy',
      'sales-process-development',
      'pipeline-management',
      'revenue-operations',
    ],
  },
  {
    id: 'revenue-operations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'revenue_operations',
    path: '/revops',
    name: 'RevenueOperationsSkillPage',
    schemaTitle: 'SkillSeoPage.revenueOperationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.revenueOperationsSchemaDescription',
    heroPill: 'SkillSeoPage.revenueOperationsHeroPill',
    heroTitle: 'SkillSeoPage.revenueOperationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.revenueOperationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.revenueOperationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.revenueOperationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.revenueOperationsFaqQuestion1',
        answer: 'SkillSeoPage.revenueOperationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.revenueOperationsFaqQuestion2',
        answer: 'SkillSeoPage.revenueOperationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.revenueOperationsFaqQuestion3',
        answer: 'SkillSeoPage.revenueOperationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-operations',
      'sales-strategy',
      'sales-process-development',
      'pipeline-management',
      'revenue-forecasting',
    ],
  },
  {
    id: 'sales-operations',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'sales_operations',
    path: '/sales-operations',
    name: 'SalesOperationsSkillPage',
    schemaTitle: 'SkillSeoPage.salesOperationsSchemaTitle',
    schemaDescription: 'SkillSeoPage.salesOperationsSchemaDescription',
    heroPill: 'SkillSeoPage.salesOperationsHeroPill',
    heroTitle: 'SkillSeoPage.salesOperationsHeroTitle',
    heroSubtitle: 'SkillSeoPage.salesOperationsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.salesOperationsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.salesOperationsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.salesOperationsFaqQuestion1',
        answer: 'SkillSeoPage.salesOperationsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.salesOperationsFaqQuestion2',
        answer: 'SkillSeoPage.salesOperationsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.salesOperationsFaqQuestion3',
        answer: 'SkillSeoPage.salesOperationsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'crm',
      'sales-strategy',
      'sales-process-development',
      'pipeline-management',
      'revenue-operations',
    ],
  },
  {
    id: 'sales-process-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'sales_process_development',
    path: '/myyntiprosessien-kehittaminen',
    name: 'SalesProcessDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.salesProcessDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.salesProcessDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.salesProcessDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.salesProcessDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.salesProcessDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.salesProcessDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.salesProcessDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.salesProcessDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.salesProcessDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.salesProcessDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.salesProcessDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.salesProcessDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.salesProcessDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'sales-operations',
      'sales-strategy',
      'pipeline-management',
      'revenue-operations',
      'revenue-forecasting',
    ],
  },
  {
    id: 'sales-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'sales_strategy',
    path: '/myyntistrategia',
    name: 'SalesStrategySkillPage',
    schemaTitle: 'SkillSeoPage.salesStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.salesStrategySchemaDescription',
    heroPill: 'SkillSeoPage.salesStrategyHeroPill',
    heroTitle: 'SkillSeoPage.salesStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.salesStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.salesStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.salesStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.salesStrategyFaqQuestion1',
        answer: 'SkillSeoPage.salesStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.salesStrategyFaqQuestion2',
        answer: 'SkillSeoPage.salesStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.salesStrategyFaqQuestion3',
        answer: 'SkillSeoPage.salesStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'gtm-strategy',
      'sales-operations',
      'sales-process-development',
      'pipeline-management',
      'revenue-operations',
    ],
  },
  {
    id: 'scriptwriting',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'scriptwriting',
    path: '/kasikirjoittaminen',
    name: 'ScriptwritingSkillPage',
    schemaTitle: 'SkillSeoPage.scriptwritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.scriptwritingSchemaDescription',
    heroPill: 'SkillSeoPage.scriptwritingHeroPill',
    heroTitle: 'SkillSeoPage.scriptwritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.scriptwritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.scriptwritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.scriptwritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.scriptwritingFaqQuestion1',
        answer: 'SkillSeoPage.scriptwritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.scriptwritingFaqQuestion2',
        answer: 'SkillSeoPage.scriptwritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.scriptwritingFaqQuestion3',
        answer: 'SkillSeoPage.scriptwritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'short-form-video-production',
      'ad-creatives',
      'user-generated-content',
      'product-description-writing',
      'copywriting',
    ],
  },
  {
    id: 'search-engine-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'search_engine_marketing',
    path: '/hakukonemarkkinointi',
    name: 'SearchEngineMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.searchEngineMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.searchEngineMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.searchEngineMarketingHeroPill',
    heroTitle: 'SkillSeoPage.searchEngineMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.searchEngineMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.searchEngineMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.searchEngineMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.searchEngineMarketingFaqQuestion1',
        answer: 'SkillSeoPage.searchEngineMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.searchEngineMarketingFaqQuestion2',
        answer: 'SkillSeoPage.searchEngineMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.searchEngineMarketingFaqQuestion3',
        answer: 'SkillSeoPage.searchEngineMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'keyword-research',
      'seo-audit',
      'growth-hacking',
      'conversion-rate-optimization',
      'marketing-automation',
    ],
  },
  {
    id: 'seo',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'seo',
    path: '/hakukoneoptimointi',
    name: 'SeoSkillPage',
    schemaTitle: 'SkillSeoPage.seoSchemaTitle',
    schemaDescription: 'SkillSeoPage.seoSchemaDescription',
    heroPill: 'SkillSeoPage.seoHeroPill',
    heroTitle: 'SkillSeoPage.seoHeroTitle',
    heroSubtitle: 'SkillSeoPage.seoHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.seoFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.seoFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.seoFaqQuestion1',
        answer: 'SkillSeoPage.seoFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.seoFaqQuestion2',
        answer: 'SkillSeoPage.seoFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.seoFaqQuestion3',
        answer: 'SkillSeoPage.seoFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-audit',
      'seo-strategy',
      'technical-seo',
      'keyword-research',
      'cookie-management',
    ],
  },
  {
    id: 'seo-audit',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'seo_audit',
    path: '/seo-auditointi',
    name: 'SeoAuditSkillPage',
    schemaTitle: 'SkillSeoPage.seoAuditSchemaTitle',
    schemaDescription: 'SkillSeoPage.seoAuditSchemaDescription',
    heroPill: 'SkillSeoPage.seoAuditHeroPill',
    heroTitle: 'SkillSeoPage.seoAuditHeroTitle',
    heroSubtitle: 'SkillSeoPage.seoAuditHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.seoAuditFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.seoAuditFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.seoAuditFaqQuestion1',
        answer: 'SkillSeoPage.seoAuditFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.seoAuditFaqQuestion2',
        answer: 'SkillSeoPage.seoAuditFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.seoAuditFaqQuestion3',
        answer: 'SkillSeoPage.seoAuditFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-strategy',
      'technical-seo',
      'keyword-research',
      'search-engine-marketing',
      'seo-writing',
    ],
  },
  {
    id: 'seo-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'seo_strategy',
    path: '/seo-strategia',
    name: 'SeoStrategySkillPage',
    schemaTitle: 'SkillSeoPage.seoStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.seoStrategySchemaDescription',
    heroPill: 'SkillSeoPage.seoStrategyHeroPill',
    heroTitle: 'SkillSeoPage.seoStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.seoStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.seoStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.seoStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.seoStrategyFaqQuestion1',
        answer: 'SkillSeoPage.seoStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.seoStrategyFaqQuestion2',
        answer: 'SkillSeoPage.seoStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.seoStrategyFaqQuestion3',
        answer: 'SkillSeoPage.seoStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-audit',
      'technical-seo',
      'keyword-research',
      'seo-writing',
      'inbound-marketing',
    ],
  },
  {
    id: 'seo-writing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'seo_writing',
    path: '/seo-sisallontuotanto',
    name: 'SeoWritingSkillPage',
    schemaTitle: 'SkillSeoPage.seoWritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.seoWritingSchemaDescription',
    heroPill: 'SkillSeoPage.seoWritingHeroPill',
    heroTitle: 'SkillSeoPage.seoWritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.seoWritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.seoWritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.seoWritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.seoWritingFaqQuestion1',
        answer: 'SkillSeoPage.seoWritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.seoWritingFaqQuestion2',
        answer: 'SkillSeoPage.seoWritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.seoWritingFaqQuestion3',
        answer: 'SkillSeoPage.seoWritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-audit',
      'seo-strategy',
      'keyword-research',
      'ghostwriting',
      'content-strategy',
    ],
  },
  {
    id: 'service-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'service_design',
    path: '/palvelumuotoilu',
    name: 'ServiceDesignSkillPage',
    schemaTitle: 'SkillSeoPage.serviceDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.serviceDesignSchemaDescription',
    heroPill: 'SkillSeoPage.serviceDesignHeroPill',
    heroTitle: 'SkillSeoPage.serviceDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.serviceDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.serviceDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.serviceDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.serviceDesignFaqQuestion1',
        answer: 'SkillSeoPage.serviceDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.serviceDesignFaqQuestion2',
        answer: 'SkillSeoPage.serviceDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.serviceDesignFaqQuestion3',
        answer: 'SkillSeoPage.serviceDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'service-development',
      'customer-oriented-development',
      'usability-testing',
      'user-research',
      'concept-development',
    ],
  },
  {
    id: 'service-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'service_development',
    path: '/palvelukehitys',
    name: 'ServiceDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.serviceDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.serviceDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.serviceDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.serviceDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.serviceDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.serviceDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.serviceDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.serviceDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.serviceDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.serviceDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.serviceDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.serviceDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.serviceDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'customer-oriented-development',
      'service-design',
      'concept-development',
      'project-management',
      'crm',
    ],
  },
  {
    id: 'short-form-video-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'short_form_video_production',
    path: '/lyhytvideot',
    name: 'ShortFormVideoProductionSkillPage',
    schemaTitle: 'SkillSeoPage.shortFormVideoProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.shortFormVideoProductionSchemaDescription',
    heroPill: 'SkillSeoPage.shortFormVideoProductionHeroPill',
    heroTitle: 'SkillSeoPage.shortFormVideoProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.shortFormVideoProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.shortFormVideoProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.shortFormVideoProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.shortFormVideoProductionFaqQuestion1',
        answer: 'SkillSeoPage.shortFormVideoProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.shortFormVideoProductionFaqQuestion2',
        answer: 'SkillSeoPage.shortFormVideoProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.shortFormVideoProductionFaqQuestion3',
        answer: 'SkillSeoPage.shortFormVideoProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'corporate-video-production',
      'video-effects',
      'scriptwriting',
      'videography',
      'content-strategy',
    ],
  },
  {
    id: 'social-media-advertising',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'social_media_advertising',
    path: '/somemainonta',
    name: 'SocialMediaAdvertisingSkillPage',
    schemaTitle: 'SkillSeoPage.socialMediaAdvertisingSchemaTitle',
    schemaDescription: 'SkillSeoPage.socialMediaAdvertisingSchemaDescription',
    heroPill: 'SkillSeoPage.socialMediaAdvertisingHeroPill',
    heroTitle: 'SkillSeoPage.socialMediaAdvertisingHeroTitle',
    heroSubtitle: 'SkillSeoPage.socialMediaAdvertisingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.socialMediaAdvertisingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.socialMediaAdvertisingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.socialMediaAdvertisingFaqQuestion1',
        answer: 'SkillSeoPage.socialMediaAdvertisingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.socialMediaAdvertisingFaqQuestion2',
        answer: 'SkillSeoPage.socialMediaAdvertisingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.socialMediaAdvertisingFaqQuestion3',
        answer: 'SkillSeoPage.socialMediaAdvertisingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'influencer-marketing',
      'social-media-strategy',
      'search-engine-marketing',
      'lead-generation',
      'instagram-marketing',
    ],
  },
  {
    id: 'social-media-content',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'social_media_content',
    path: '/sosiaalisen-median-sisallot',
    name: 'SocialMediaContentSkillPage',
    schemaTitle: 'SkillSeoPage.socialMediaContentSchemaTitle',
    schemaDescription: 'SkillSeoPage.socialMediaContentSchemaDescription',
    heroPill: 'SkillSeoPage.socialMediaContentHeroPill',
    heroTitle: 'SkillSeoPage.socialMediaContentHeroTitle',
    heroSubtitle: 'SkillSeoPage.socialMediaContentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.socialMediaContentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.socialMediaContentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.socialMediaContentFaqQuestion1',
        answer: 'SkillSeoPage.socialMediaContentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.socialMediaContentFaqQuestion2',
        answer: 'SkillSeoPage.socialMediaContentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.socialMediaContentFaqQuestion3',
        answer: 'SkillSeoPage.socialMediaContentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'ghostwriting',
      'social-media-strategy',
      'user-generated-content',
      'media-relations',
      'scriptwriting',
    ],
  },
  {
    id: 'social-media-marketing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'social_media_marketing',
    path: '/somemarkkinointi',
    name: 'SocialMediaMarketingSkillPage',
    schemaTitle: 'SkillSeoPage.socialMediaMarketingSchemaTitle',
    schemaDescription: 'SkillSeoPage.socialMediaMarketingSchemaDescription',
    heroPill: 'SkillSeoPage.socialMediaMarketingHeroPill',
    heroTitle: 'SkillSeoPage.socialMediaMarketingHeroTitle',
    heroSubtitle: 'SkillSeoPage.socialMediaMarketingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.socialMediaMarketingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.socialMediaMarketingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.socialMediaMarketingFaqQuestion1',
        answer: 'SkillSeoPage.socialMediaMarketingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.socialMediaMarketingFaqQuestion2',
        answer: 'SkillSeoPage.socialMediaMarketingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.socialMediaMarketingFaqQuestion3',
        answer: 'SkillSeoPage.socialMediaMarketingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'social-media-strategy',
      'instagram-marketing',
      'search-engine-marketing',
      'user-generated-content',
      'content-strategy',
    ],
  },
  {
    id: 'social-media-strategy',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'social_media_strategy',
    path: '/somestrategia',
    name: 'SocialMediaStrategySkillPage',
    schemaTitle: 'SkillSeoPage.socialMediaStrategySchemaTitle',
    schemaDescription: 'SkillSeoPage.socialMediaStrategySchemaDescription',
    heroPill: 'SkillSeoPage.socialMediaStrategyHeroPill',
    heroTitle: 'SkillSeoPage.socialMediaStrategyHeroTitle',
    heroSubtitle: 'SkillSeoPage.socialMediaStrategyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.socialMediaStrategyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.socialMediaStrategyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.socialMediaStrategyFaqQuestion1',
        answer: 'SkillSeoPage.socialMediaStrategyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.socialMediaStrategyFaqQuestion2',
        answer: 'SkillSeoPage.socialMediaStrategyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.socialMediaStrategyFaqQuestion3',
        answer: 'SkillSeoPage.socialMediaStrategyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'media-strategy',
      'content-strategy',
      'media-relations',
      'social-media-marketing',
      'event-marketing',
    ],
  },
  {
    id: 'social-media-video-creation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'social_media_video_creation',
    path: '/somevideot',
    name: 'SocialMediaVideoCreationSkillPage',
    schemaTitle: 'SkillSeoPage.socialMediaVideoCreationSchemaTitle',
    schemaDescription: 'SkillSeoPage.socialMediaVideoCreationSchemaDescription',
    heroPill: 'SkillSeoPage.socialMediaVideoCreationHeroPill',
    heroTitle: 'SkillSeoPage.socialMediaVideoCreationHeroTitle',
    heroSubtitle: 'SkillSeoPage.socialMediaVideoCreationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.socialMediaVideoCreationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.socialMediaVideoCreationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.socialMediaVideoCreationFaqQuestion1',
        answer: 'SkillSeoPage.socialMediaVideoCreationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.socialMediaVideoCreationFaqQuestion2',
        answer: 'SkillSeoPage.socialMediaVideoCreationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.socialMediaVideoCreationFaqQuestion3',
        answer: 'SkillSeoPage.socialMediaVideoCreationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'short-form-video-production',
      'video-effects',
      'corporate-video-production',
      'videography',
      'user-generated-content',
    ],
  },
  {
    id: 'sound-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'sound_design',
    path: '/aanisuunnittelu',
    name: 'SoundDesignSkillPage',
    schemaTitle: 'SkillSeoPage.soundDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.soundDesignSchemaDescription',
    heroPill: 'SkillSeoPage.soundDesignHeroPill',
    heroTitle: 'SkillSeoPage.soundDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.soundDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.soundDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.soundDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.soundDesignFaqQuestion1',
        answer: 'SkillSeoPage.soundDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.soundDesignFaqQuestion2',
        answer: 'SkillSeoPage.soundDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.soundDesignFaqQuestion3',
        answer: 'SkillSeoPage.soundDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'audio-mixing',
      'audio-editing',
      'corporate-video-production',
      'video-production',
      'video-editing',
    ],
  },
  {
    id: 'studio-photography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'studio_photography',
    path: '/studiokuvaus',
    name: 'StudioPhotographySkillPage',
    schemaTitle: 'SkillSeoPage.studioPhotographySchemaTitle',
    schemaDescription: 'SkillSeoPage.studioPhotographySchemaDescription',
    heroPill: 'SkillSeoPage.studioPhotographyHeroPill',
    heroTitle: 'SkillSeoPage.studioPhotographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.studioPhotographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.studioPhotographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.studioPhotographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.studioPhotographyFaqQuestion1',
        answer: 'SkillSeoPage.studioPhotographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.studioPhotographyFaqQuestion2',
        answer: 'SkillSeoPage.studioPhotographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.studioPhotographyFaqQuestion3',
        answer: 'SkillSeoPage.studioPhotographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'portrait-photography',
      'image-retouching',
      'event-photography',
      'product-photography',
      'real-estate-photography',
    ],
  },
  {
    id: 'subtitles',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'subtitles',
    path: '/tekstitys',
    name: 'SubtitlesSkillPage',
    schemaTitle: 'SkillSeoPage.subtitlesSchemaTitle',
    schemaDescription: 'SkillSeoPage.subtitlesSchemaDescription',
    heroPill: 'SkillSeoPage.subtitlesHeroPill',
    heroTitle: 'SkillSeoPage.subtitlesHeroTitle',
    heroSubtitle: 'SkillSeoPage.subtitlesHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.subtitlesFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.subtitlesFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.subtitlesFaqQuestion1',
        answer: 'SkillSeoPage.subtitlesFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.subtitlesFaqQuestion2',
        answer: 'SkillSeoPage.subtitlesFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.subtitlesFaqQuestion3',
        answer: 'SkillSeoPage.subtitlesFaqAnswer3',
      },
    ],
    relatedSkills: [
      'transcription',
      'translation',
      'proofreading',
      'portrait-photography',
      'audio-editing',
    ],
  },
  {
    id: 'system-architecture',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'system_architecture',
    path: '/jarjestelmaarkkitehtuuri',
    name: 'SystemArchitectureSkillPage',
    schemaTitle: 'SkillSeoPage.systemArchitectureSchemaTitle',
    schemaDescription: 'SkillSeoPage.systemArchitectureSchemaDescription',
    heroPill: 'SkillSeoPage.systemArchitectureHeroPill',
    heroTitle: 'SkillSeoPage.systemArchitectureHeroTitle',
    heroSubtitle: 'SkillSeoPage.systemArchitectureHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.systemArchitectureFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.systemArchitectureFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.systemArchitectureFaqQuestion1',
        answer: 'SkillSeoPage.systemArchitectureFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.systemArchitectureFaqQuestion2',
        answer: 'SkillSeoPage.systemArchitectureFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.systemArchitectureFaqQuestion3',
        answer: 'SkillSeoPage.systemArchitectureFaqAnswer3',
      },
    ],
    relatedSkills: [
      'application-architecture',
      'api-development',
      'automations',
      'back-end-development',
      'database-management',
    ],
  },
  {
    id: 'target-group-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'target_group_research',
    path: '/kohderyhmatutkimus',
    name: 'TargetGroupResearchSkillPage',
    schemaTitle: 'SkillSeoPage.targetGroupResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.targetGroupResearchSchemaDescription',
    heroPill: 'SkillSeoPage.targetGroupResearchHeroPill',
    heroTitle: 'SkillSeoPage.targetGroupResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.targetGroupResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.targetGroupResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.targetGroupResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.targetGroupResearchFaqQuestion1',
        answer: 'SkillSeoPage.targetGroupResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.targetGroupResearchFaqQuestion2',
        answer: 'SkillSeoPage.targetGroupResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.targetGroupResearchFaqQuestion3',
        answer: 'SkillSeoPage.targetGroupResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'market-research',
      'market-segmentation',
      'consumer-research',
      'brand-research',
      'user-research',
    ],
  },
  {
    id: 'technical-seo',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'technical_seo',
    path: '/tekninen-seo',
    name: 'TechnicalSeoSkillPage',
    schemaTitle: 'SkillSeoPage.technicalSeoSchemaTitle',
    schemaDescription: 'SkillSeoPage.technicalSeoSchemaDescription',
    heroPill: 'SkillSeoPage.technicalSeoHeroPill',
    heroTitle: 'SkillSeoPage.technicalSeoHeroTitle',
    heroSubtitle: 'SkillSeoPage.technicalSeoHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.technicalSeoFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.technicalSeoFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.technicalSeoFaqQuestion1',
        answer: 'SkillSeoPage.technicalSeoFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.technicalSeoFaqQuestion2',
        answer: 'SkillSeoPage.technicalSeoFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.technicalSeoFaqQuestion3',
        answer: 'SkillSeoPage.technicalSeoFaqAnswer3',
      },
    ],
    relatedSkills: [
      'seo-audit',
      'seo-strategy',
      'keyword-research',
      'growth-hacking',
      'search-engine-marketing',
    ],
  },
  {
    id: 'transcription',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'transcription',
    path: '/litterointi',
    name: 'TranscriptionSkillPage',
    schemaTitle: 'SkillSeoPage.transcriptionSchemaTitle',
    schemaDescription: 'SkillSeoPage.transcriptionSchemaDescription',
    heroPill: 'SkillSeoPage.transcriptionHeroPill',
    heroTitle: 'SkillSeoPage.transcriptionHeroTitle',
    heroSubtitle: 'SkillSeoPage.transcriptionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.transcriptionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.transcriptionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.transcriptionFaqQuestion1',
        answer: 'SkillSeoPage.transcriptionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.transcriptionFaqQuestion2',
        answer: 'SkillSeoPage.transcriptionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.transcriptionFaqQuestion3',
        answer: 'SkillSeoPage.transcriptionFaqAnswer3',
      },
    ],
    relatedSkills: ['subtitles', 'proofreading', 'voice-over', 'data-entry', 'translation'],
  },
  {
    id: 'translation',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'translation',
    path: '/kaantaminen',
    name: 'TranslationSkillPage',
    schemaTitle: 'SkillSeoPage.translationSchemaTitle',
    schemaDescription: 'SkillSeoPage.translationSchemaDescription',
    heroPill: 'SkillSeoPage.translationHeroPill',
    heroTitle: 'SkillSeoPage.translationHeroTitle',
    heroSubtitle: 'SkillSeoPage.translationHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.translationFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.translationFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.translationFaqQuestion1',
        answer: 'SkillSeoPage.translationFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.translationFaqQuestion2',
        answer: 'SkillSeoPage.translationFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.translationFaqQuestion3',
        answer: 'SkillSeoPage.translationFaqAnswer3',
      },
    ],
    relatedSkills: [
      'subtitles',
      'transcription',
      'proofreading',
      'natural-language-processing',
      'data-entry',
    ],
  },
  {
    id: 'ui-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ui_design',
    path: '/kayttoliittymasuunnittelu',
    name: 'UiDesignSkillPage',
    schemaTitle: 'SkillSeoPage.uiDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.uiDesignSchemaDescription',
    heroPill: 'SkillSeoPage.uiDesignHeroPill',
    heroTitle: 'SkillSeoPage.uiDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.uiDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.uiDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.uiDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.uiDesignFaqQuestion1',
        answer: 'SkillSeoPage.uiDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.uiDesignFaqQuestion2',
        answer: 'SkillSeoPage.uiDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.uiDesignFaqQuestion3',
        answer: 'SkillSeoPage.uiDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'accessibility-testing',
      'mobile-app-design',
      'user-research',
      'user-interface-testing',
      'user-experience-testing',
    ],
  },
  {
    id: 'usability-testing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'usability_testing',
    path: '/kaytettavyystestaus',
    name: 'UsabilityTestingSkillPage',
    schemaTitle: 'SkillSeoPage.usabilityTestingSchemaTitle',
    schemaDescription: 'SkillSeoPage.usabilityTestingSchemaDescription',
    heroPill: 'SkillSeoPage.usabilityTestingHeroPill',
    heroTitle: 'SkillSeoPage.usabilityTestingHeroTitle',
    heroSubtitle: 'SkillSeoPage.usabilityTestingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.usabilityTestingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.usabilityTestingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.usabilityTestingFaqQuestion1',
        answer: 'SkillSeoPage.usabilityTestingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.usabilityTestingFaqQuestion2',
        answer: 'SkillSeoPage.usabilityTestingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.usabilityTestingFaqQuestion3',
        answer: 'SkillSeoPage.usabilityTestingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'user-interface-testing',
      'user-experience-testing',
      'ux-writing',
      'user-research',
      'service-design',
    ],
  },
  {
    id: 'user-experience-testing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'user_experience_testing',
    path: '/kayttokokemusten-testaus',
    name: 'UserExperienceTestingSkillPage',
    schemaTitle: 'SkillSeoPage.userExperienceTestingSchemaTitle',
    schemaDescription: 'SkillSeoPage.userExperienceTestingSchemaDescription',
    heroPill: 'SkillSeoPage.userExperienceTestingHeroPill',
    heroTitle: 'SkillSeoPage.userExperienceTestingHeroTitle',
    heroSubtitle: 'SkillSeoPage.userExperienceTestingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.userExperienceTestingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.userExperienceTestingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.userExperienceTestingFaqQuestion1',
        answer: 'SkillSeoPage.userExperienceTestingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.userExperienceTestingFaqQuestion2',
        answer: 'SkillSeoPage.userExperienceTestingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.userExperienceTestingFaqQuestion3',
        answer: 'SkillSeoPage.userExperienceTestingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'user-interface-testing',
      'usability-testing',
      'user-research',
      'ux-design',
      'ui-design',
    ],
  },
  {
    id: 'user-generated-content',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'user_generated_content',
    path: '/ugc',
    name: 'UserGeneratedContentSkillPage',
    schemaTitle: 'SkillSeoPage.userGeneratedContentSchemaTitle',
    schemaDescription: 'SkillSeoPage.userGeneratedContentSchemaDescription',
    heroPill: 'SkillSeoPage.userGeneratedContentHeroPill',
    heroTitle: 'SkillSeoPage.userGeneratedContentHeroTitle',
    heroSubtitle: 'SkillSeoPage.userGeneratedContentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.userGeneratedContentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.userGeneratedContentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.userGeneratedContentFaqQuestion1',
        answer: 'SkillSeoPage.userGeneratedContentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.userGeneratedContentFaqQuestion2',
        answer: 'SkillSeoPage.userGeneratedContentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.userGeneratedContentFaqQuestion3',
        answer: 'SkillSeoPage.userGeneratedContentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'scriptwriting',
      'event-marketing',
      'content-strategy',
      'brand-partnership',
      'social-media-video-creation',
    ],
  },
  {
    id: 'user-interface-testing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'user_interface_testing',
    path: '/kayttoliittyman-testaus',
    name: 'UserInterfaceTestingSkillPage',
    schemaTitle: 'SkillSeoPage.userInterfaceTestingSchemaTitle',
    schemaDescription: 'SkillSeoPage.userInterfaceTestingSchemaDescription',
    heroPill: 'SkillSeoPage.userInterfaceTestingHeroPill',
    heroTitle: 'SkillSeoPage.userInterfaceTestingHeroTitle',
    heroSubtitle: 'SkillSeoPage.userInterfaceTestingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.userInterfaceTestingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.userInterfaceTestingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.userInterfaceTestingFaqQuestion1',
        answer: 'SkillSeoPage.userInterfaceTestingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.userInterfaceTestingFaqQuestion2',
        answer: 'SkillSeoPage.userInterfaceTestingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.userInterfaceTestingFaqQuestion3',
        answer: 'SkillSeoPage.userInterfaceTestingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'usability-testing',
      'user-experience-testing',
      'user-research',
      'ui-design',
      'mobile-app-design',
    ],
  },
  {
    id: 'user-research',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'user_research',
    path: '/kayttajatutkimus',
    name: 'UserResearchSkillPage',
    schemaTitle: 'SkillSeoPage.userResearchSchemaTitle',
    schemaDescription: 'SkillSeoPage.userResearchSchemaDescription',
    heroPill: 'SkillSeoPage.userResearchHeroPill',
    heroTitle: 'SkillSeoPage.userResearchHeroTitle',
    heroSubtitle: 'SkillSeoPage.userResearchHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.userResearchFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.userResearchFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.userResearchFaqQuestion1',
        answer: 'SkillSeoPage.userResearchFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.userResearchFaqQuestion2',
        answer: 'SkillSeoPage.userResearchFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.userResearchFaqQuestion3',
        answer: 'SkillSeoPage.userResearchFaqAnswer3',
      },
    ],
    relatedSkills: [
      'mobile-app-design',
      'user-experience-testing',
      'user-interface-testing',
      'usability-testing',
      'ui-design',
    ],
  },
  {
    id: 'ux-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ux_design',
    path: '/ux-suunnittelu',
    name: 'UxDesignSkillPage',
    schemaTitle: 'SkillSeoPage.uxDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.uxDesignSchemaDescription',
    heroPill: 'SkillSeoPage.uxDesignHeroPill',
    heroTitle: 'SkillSeoPage.uxDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.uxDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.uxDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.uxDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.uxDesignFaqQuestion1',
        answer: 'SkillSeoPage.uxDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.uxDesignFaqQuestion2',
        answer: 'SkillSeoPage.uxDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.uxDesignFaqQuestion3',
        answer: 'SkillSeoPage.uxDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'user-experience-testing',
      'user-research',
      'mobile-app-design',
      'ui-design',
      'user-interface-testing',
    ],
  },
  {
    id: 'ux-writing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'ux_writing',
    path: '/ux-kirjoittaminen',
    name: 'UxWritingSkillPage',
    schemaTitle: 'SkillSeoPage.uxWritingSchemaTitle',
    schemaDescription: 'SkillSeoPage.uxWritingSchemaDescription',
    heroPill: 'SkillSeoPage.uxWritingHeroPill',
    heroTitle: 'SkillSeoPage.uxWritingHeroTitle',
    heroSubtitle: 'SkillSeoPage.uxWritingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.uxWritingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.uxWritingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.uxWritingFaqQuestion1',
        answer: 'SkillSeoPage.uxWritingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.uxWritingFaqQuestion2',
        answer: 'SkillSeoPage.uxWritingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.uxWritingFaqQuestion3',
        answer: 'SkillSeoPage.uxWritingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'usability-testing',
      'user-research',
      'mobile-app-design',
      'ui-design',
      'ux-design',
    ],
  },
  {
    id: 'vector-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'vector_design',
    path: '/vektorointi',
    name: 'VectorDesignSkillPage',
    schemaTitle: 'SkillSeoPage.vectorDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.vectorDesignSchemaDescription',
    heroPill: 'SkillSeoPage.vectorDesignHeroPill',
    heroTitle: 'SkillSeoPage.vectorDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.vectorDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.vectorDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.vectorDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.vectorDesignFaqQuestion1',
        answer: 'SkillSeoPage.vectorDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.vectorDesignFaqQuestion2',
        answer: 'SkillSeoPage.vectorDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.vectorDesignFaqQuestion3',
        answer: 'SkillSeoPage.vectorDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'drawing',
      'book-layout',
      'book-cover-design',
      'image-retouching',
      'character-design',
    ],
  },
  {
    id: 'video-editing',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'video_editing',
    path: '/videoeditointi',
    name: 'VideoEditingSkillPage',
    schemaTitle: 'SkillSeoPage.videoEditingSchemaTitle',
    schemaDescription: 'SkillSeoPage.videoEditingSchemaDescription',
    heroPill: 'SkillSeoPage.videoEditingHeroPill',
    heroTitle: 'SkillSeoPage.videoEditingHeroTitle',
    heroSubtitle: 'SkillSeoPage.videoEditingHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.videoEditingFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.videoEditingFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.videoEditingFaqQuestion1',
        answer: 'SkillSeoPage.videoEditingFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.videoEditingFaqQuestion2',
        answer: 'SkillSeoPage.videoEditingFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.videoEditingFaqQuestion3',
        answer: 'SkillSeoPage.videoEditingFaqAnswer3',
      },
    ],
    relatedSkills: [
      'video-effects',
      'corporate-video-production',
      'videography',
      'short-form-video-production',
      'video-production',
    ],
  },
  {
    id: 'video-effects',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'video_effects',
    path: '/videoefektit',
    name: 'VideoEffectsSkillPage',
    schemaTitle: 'SkillSeoPage.videoEffectsSchemaTitle',
    schemaDescription: 'SkillSeoPage.videoEffectsSchemaDescription',
    heroPill: 'SkillSeoPage.videoEffectsHeroPill',
    heroTitle: 'SkillSeoPage.videoEffectsHeroTitle',
    heroSubtitle: 'SkillSeoPage.videoEffectsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.videoEffectsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.videoEffectsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.videoEffectsFaqQuestion1',
        answer: 'SkillSeoPage.videoEffectsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.videoEffectsFaqQuestion2',
        answer: 'SkillSeoPage.videoEffectsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.videoEffectsFaqQuestion3',
        answer: 'SkillSeoPage.videoEffectsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'motion-graphics',
      'corporate-video-production',
      '2d-animation',
      'ai-video-production',
      'image-retouching',
    ],
  },
  {
    id: 'video-production',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'video_production',
    path: '/videotuotanto',
    name: 'VideoProductionSkillPage',
    schemaTitle: 'SkillSeoPage.videoProductionSchemaTitle',
    schemaDescription: 'SkillSeoPage.videoProductionSchemaDescription',
    heroPill: 'SkillSeoPage.videoProductionHeroPill',
    heroTitle: 'SkillSeoPage.videoProductionHeroTitle',
    heroSubtitle: 'SkillSeoPage.videoProductionHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.videoProductionFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.videoProductionFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.videoProductionFaqQuestion1',
        answer: 'SkillSeoPage.videoProductionFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.videoProductionFaqQuestion2',
        answer: 'SkillSeoPage.videoProductionFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.videoProductionFaqQuestion3',
        answer: 'SkillSeoPage.videoProductionFaqAnswer3',
      },
    ],
    relatedSkills: [
      'corporate-video-production',
      'videography',
      'video-effects',
      'short-form-video-production',
      'drone-videography',
    ],
  },
  {
    id: 'videography',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'videography',
    path: '/videokuvaus',
    name: 'VideographySkillPage',
    schemaTitle: 'SkillSeoPage.videographySchemaTitle',
    schemaDescription: 'SkillSeoPage.videographySchemaDescription',
    heroPill: 'SkillSeoPage.videographyHeroPill',
    heroTitle: 'SkillSeoPage.videographyHeroTitle',
    heroSubtitle: 'SkillSeoPage.videographyHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.videographyFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.videographyFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.videographyFaqQuestion1',
        answer: 'SkillSeoPage.videographyFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.videographyFaqQuestion2',
        answer: 'SkillSeoPage.videographyFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.videographyFaqQuestion3',
        answer: 'SkillSeoPage.videographyFaqAnswer3',
      },
    ],
    relatedSkills: [
      'corporate-video-production',
      'event-photography',
      'real-estate-photography',
      'drone-videography',
      'video-effects',
    ],
  },
  {
    id: 'virtual-assistance',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'virtual_assistance',
    path: '/virtuaaliassistentti',
    name: 'VirtualAssistanceSkillPage',
    schemaTitle: 'SkillSeoPage.virtualAssistanceSchemaTitle',
    schemaDescription: 'SkillSeoPage.virtualAssistanceSchemaDescription',
    heroPill: 'SkillSeoPage.virtualAssistanceHeroPill',
    heroTitle: 'SkillSeoPage.virtualAssistanceHeroTitle',
    heroSubtitle: 'SkillSeoPage.virtualAssistanceHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.virtualAssistanceFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.virtualAssistanceFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.virtualAssistanceFaqQuestion1',
        answer: 'SkillSeoPage.virtualAssistanceFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.virtualAssistanceFaqQuestion2',
        answer: 'SkillSeoPage.virtualAssistanceFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.virtualAssistanceFaqQuestion3',
        answer: 'SkillSeoPage.virtualAssistanceFaqAnswer3',
      },
    ],
    relatedSkills: [
      'recruitment',
      'data-entry',
      'internal-communication',
      'product-description-writing',
      'crm',
    ],
  },
  {
    id: 'virtual-reality',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'virtual_reality',
    path: '/virtuaalitodellisuus',
    name: 'VirtualRealitySkillPage',
    schemaTitle: 'SkillSeoPage.virtualRealitySchemaTitle',
    schemaDescription: 'SkillSeoPage.virtualRealitySchemaDescription',
    heroPill: 'SkillSeoPage.virtualRealityHeroPill',
    heroTitle: 'SkillSeoPage.virtualRealityHeroTitle',
    heroSubtitle: 'SkillSeoPage.virtualRealityHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.virtualRealityFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.virtualRealityFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.virtualRealityFaqQuestion1',
        answer: 'SkillSeoPage.virtualRealityFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.virtualRealityFaqQuestion2',
        answer: 'SkillSeoPage.virtualRealityFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.virtualRealityFaqQuestion3',
        answer: 'SkillSeoPage.virtualRealityFaqAnswer3',
      },
    ],
    relatedSkills: ['augmented-reality', 'arvr-content-creation', '3d-modeling', '3d-animation'],
  },
  {
    id: 'voice-over',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'voice_over',
    path: '/spiikkaukset',
    name: 'VoiceOverSkillPage',
    schemaTitle: 'SkillSeoPage.voiceOverSchemaTitle',
    schemaDescription: 'SkillSeoPage.voiceOverSchemaDescription',
    heroPill: 'SkillSeoPage.voiceOverHeroPill',
    heroTitle: 'SkillSeoPage.voiceOverHeroTitle',
    heroSubtitle: 'SkillSeoPage.voiceOverHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.voiceOverFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.voiceOverFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.voiceOverFaqQuestion1',
        answer: 'SkillSeoPage.voiceOverFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.voiceOverFaqQuestion2',
        answer: 'SkillSeoPage.voiceOverFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.voiceOverFaqQuestion3',
        answer: 'SkillSeoPage.voiceOverFaqAnswer3',
      },
    ],
    relatedSkills: [
      'podcast-production',
      'transcription',
      'audio-editing',
      'social-media-video-creation',
      'video-editing',
    ],
  },
  {
    id: 'wcag-standards',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'wcag_standards',
    path: '/wcag-standardit',
    name: 'WcagStandardsSkillPage',
    schemaTitle: 'SkillSeoPage.wcagStandardsSchemaTitle',
    schemaDescription: 'SkillSeoPage.wcagStandardsSchemaDescription',
    heroPill: 'SkillSeoPage.wcagStandardsHeroPill',
    heroTitle: 'SkillSeoPage.wcagStandardsHeroTitle',
    heroSubtitle: 'SkillSeoPage.wcagStandardsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.wcagStandardsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.wcagStandardsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.wcagStandardsFaqQuestion1',
        answer: 'SkillSeoPage.wcagStandardsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.wcagStandardsFaqQuestion2',
        answer: 'SkillSeoPage.wcagStandardsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.wcagStandardsFaqQuestion3',
        answer: 'SkillSeoPage.wcagStandardsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'accessibility-testing',
      'accessible-content',
      'ui-design',
      'usability-testing',
      'user-experience-testing',
    ],
  },
  {
    id: 'web-analytics',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'web_analytics',
    path: '/web-analytiikka',
    name: 'WebAnalyticsSkillPage',
    schemaTitle: 'SkillSeoPage.webAnalyticsSchemaTitle',
    schemaDescription: 'SkillSeoPage.webAnalyticsSchemaDescription',
    heroPill: 'SkillSeoPage.webAnalyticsHeroPill',
    heroTitle: 'SkillSeoPage.webAnalyticsHeroTitle',
    heroSubtitle: 'SkillSeoPage.webAnalyticsHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.webAnalyticsFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.webAnalyticsFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.webAnalyticsFaqQuestion1',
        answer: 'SkillSeoPage.webAnalyticsFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.webAnalyticsFaqQuestion2',
        answer: 'SkillSeoPage.webAnalyticsFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.webAnalyticsFaqQuestion3',
        answer: 'SkillSeoPage.webAnalyticsFaqAnswer3',
      },
    ],
    relatedSkills: [
      'cookie-management',
      'conversion-rate-optimization',
      'ab-testing',
      'growth-hacking',
      'technical-seo',
    ],
  },
  {
    id: 'web-development',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'web_development',
    path: '/webkehitys',
    name: 'WebDevelopmentSkillPage',
    schemaTitle: 'SkillSeoPage.webDevelopmentSchemaTitle',
    schemaDescription: 'SkillSeoPage.webDevelopmentSchemaDescription',
    heroPill: 'SkillSeoPage.webDevelopmentHeroPill',
    heroTitle: 'SkillSeoPage.webDevelopmentHeroTitle',
    heroSubtitle: 'SkillSeoPage.webDevelopmentHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.webDevelopmentFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.webDevelopmentFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.webDevelopmentFaqQuestion1',
        answer: 'SkillSeoPage.webDevelopmentFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.webDevelopmentFaqQuestion2',
        answer: 'SkillSeoPage.webDevelopmentFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.webDevelopmentFaqQuestion3',
        answer: 'SkillSeoPage.webDevelopmentFaqAnswer3',
      },
    ],
    relatedSkills: [
      'android-development',
      'ios-development',
      'mobile-app-development',
      'back-end-development',
      'api-development',
    ],
  },
  {
    id: 'website-design',
    // Exact skill key in publicData.experienceKeys / listing publicData.authorSkillsKeys.
    skillKey: 'website_design',
    path: '/verkkosivujen-suunnittelu',
    name: 'WebsiteDesignSkillPage',
    schemaTitle: 'SkillSeoPage.websiteDesignSchemaTitle',
    schemaDescription: 'SkillSeoPage.websiteDesignSchemaDescription',
    heroPill: 'SkillSeoPage.websiteDesignHeroPill',
    heroTitle: 'SkillSeoPage.websiteDesignHeroTitle',
    heroSubtitle: 'SkillSeoPage.websiteDesignHeroSubtitle',
    findMoreFreelancersText: 'SkillSeoPage.websiteDesignFindMoreFreelancersText',
    faqTitle: 'SkillSeoPage.websiteDesignFaqTitle',
    faqItems: [
      {
        question: 'SkillSeoPage.websiteDesignFaqQuestion1',
        answer: 'SkillSeoPage.websiteDesignFaqAnswer1',
      },
      {
        question: 'SkillSeoPage.websiteDesignFaqQuestion2',
        answer: 'SkillSeoPage.websiteDesignFaqAnswer2',
      },
      {
        question: 'SkillSeoPage.websiteDesignFaqQuestion3',
        answer: 'SkillSeoPage.websiteDesignFaqAnswer3',
      },
    ],
    relatedSkills: [
      'accessibility-testing',
      'e-commerce-design',
      'mobile-app-design',
      'landing-page-design',
      'ui-design',
    ],
  },
];
